import React, { useState, useEffect, useCallback } from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import { toast } from "react-toastify";
import API_BASE_URL from "../config";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

/* ─── CSS ─────────────────────────────────────────────────── */
const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,400&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons+Round');

.ee-root *{box-sizing:border-box;margin:0;padding:0;}
.ee-root{
  --bg:#F3F4F8;--surface:#FFFFFF;--surface2:#F8F9FC;
  --border:#E4E6EF;--border2:#D0D3E0;
  --text:#18192A;--text2:#5B5E7A;--text3:#9EA2B8;
  --accent:#2563EB;--accent-light:#EFF4FF;--accent-mid:#BFCFFF;
  --green:#16A34A;--green-bg:#F0FDF4;--green-bd:#BBF7D0;
  --amber:#D97706;--amber-bg:#FFFBEB;--amber-bd:#FDE68A;
  --red:#DC2626;--red-bg:#FEF2F2;--red-bd:#FECACA;
  --violet:#7C3AED;--violet-bg:#F5F3FF;--violet-bd:#DDD6FE;
  --teal:#0D9488;--teal-bg:#F0FDFA;--teal-bd:#99F6E4;
  --sidebar:#FFFFFF;--sidebar2:#F8F9FC;
  --radius:14px;--radius-sm:8px;
  --shadow:0 1px 3px rgba(0,0,0,.08),0 4px 16px rgba(0,0,0,.04);
  font-family:'Outfit',sans-serif;color:var(--text);background:var(--bg);
  display:flex;height:calc(100vh - 106px);overflow:hidden;
}

/* ── sidebar ── */
.ee-sidebar{width:248px;min-width:248px;background:var(--sidebar);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;}
.ee-brand{height:52px;padding:0 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;flex-shrink:0;background:var(--sidebar);}
.ee-brand-logo{display:flex;align-items:center;gap:10px;}
.ee-brand-icon{width:36px;height:36px;border-radius:10px;background:linear-gradient(135deg,#3B82F6,#6366F1);display:flex;align-items:center;justify-content:center;flex-shrink:0;}
.ee-brand-icon .ee-mi{font-size:19px;color:#fff;}
.ee-brand-name{font-size:17px;font-weight:700;color:var(--text);letter-spacing:.3px;}
.ee-brand-tag{font-size:10px;color:var(--text3);letter-spacing:1.5px;text-transform:uppercase;margin-top:2px;}
.ee-user-chip{margin:14px 12px;background:linear-gradient(135deg,#F8FAFF,#F2F5FF);border:1px solid #D7DDFB;border-radius:10px;padding:10px 12px;display:flex;align-items:center;gap:10px;}
.ee-user-av{width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#3B82F6,#6366F1);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;flex-shrink:0;}
.ee-user-name{font-size:13px;font-weight:500;color:var(--text);}
.ee-user-role{font-size:10px;color:var(--text3);margin-top:1px;}
.ee-nav-section{padding:16px 12px 4px;font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:#A0A6C0;font-weight:500;}
.ee-nav-scroll{flex:1;overflow-y:auto;overflow-x:hidden;}
.ee-nav-scroll::-webkit-scrollbar{width:3px;}
.ee-nav-scroll::-webkit-scrollbar-thumb{background:#D7DBEB;border-radius:3px;}
.ee-nav-item{display:flex;align-items:center;gap:10px;padding:9px 14px;font-size:13px;color:var(--text2);cursor:pointer;border-radius:9px;margin:1px 8px;transition:all .15s;user-select:none;}
.ee-nav-item:hover{background:#F4F6FD;color:var(--text);}
.ee-nav-item.active{background:#EEF2FF;color:var(--accent);font-weight:600;}
.ee-nav-item .ee-mi{font-size:18px;}
.ee-nav-badge{margin-left:auto;min-width:20px;height:20px;background:#EF4444;border-radius:10px;font-size:10px;color:#fff;display:flex;align-items:center;justify-content:center;padding:0 5px;font-weight:600;}
.ee-nav-badge-green{background:#16A34A;}
.ee-sidebar-foot{padding:14px 12px;border-top:1px solid var(--border);background:var(--sidebar);}
.ee-nav-item.foot-item{color:var(--text3);}

/* ── main ── */
.ee-main{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0;}
.ee-topbar{height:52px;min-height:52px;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;padding:0 24px;gap:12px;flex-shrink:0;}
.ee-topbar-title{font-size:14px;font-weight:600;color:var(--text);}
.ee-topbar-right{margin-left:auto;display:flex;align-items:center;gap:8px;position:relative;}
.ee-icon-btn{width:34px;height:34px;border-radius:8px;border:1px solid var(--border);background:var(--surface);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text2);transition:all .15s;position:relative;}
.ee-icon-btn:hover{background:var(--surface2);border-color:var(--border2);}
.ee-notif-dot{position:absolute;top:6px;right:6px;width:7px;height:7px;background:#EF4444;border-radius:50%;border:1.5px solid #fff;}
.ee-top-av{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#3B82F6,#6366F1);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;cursor:pointer;}

/* ── content ── */
.ee-content{flex:1;overflow-y:auto;padding:24px 28px;display:flex;flex-direction:column;gap:20px;}
.ee-content::-webkit-scrollbar{width:5px;}
.ee-content::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px;}

/* tables */
.ee-tbl-wrap::-webkit-scrollbar{height:4px;width:4px;}
.ee-tbl-wrap::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px;}
.ee-tbl-wrap::-webkit-scrollbar-track{background:transparent;}

/* ── material icon ── */
.ee-mi{font-family:'Material Icons Round';font-style:normal;font-weight:400;font-size:20px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;}

/* ── greeting banner ── */
.ee-greet{background:linear-gradient(135deg,#1E40AF 0%,#3B82F6 50%,#06B6D4 100%);border-radius:var(--radius);padding:22px 26px;display:flex;align-items:center;justify-content:space-between;position:relative;overflow:hidden;}
.ee-greet::before{content:'';position:absolute;top:-30px;right:-30px;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%;}
.ee-greet::after{content:'';position:absolute;bottom:-50px;right:100px;width:120px;height:120px;background:rgba(255,255,255,.04);border-radius:50%;}
.ee-greet-text h2{font-size:20px;font-weight:700;color:#fff;}
.ee-greet-text p{font-size:13px;color:rgba(255,255,255,.7);margin-top:3px;}
.ee-greet-stats{display:flex;gap:20px;z-index:1;}
.ee-greet-stat{text-align:center;}
.ee-greet-stat-val{font-size:22px;font-weight:700;color:#fff;}
.ee-greet-stat-lbl{font-size:10px;color:rgba(255,255,255,.6);text-transform:uppercase;letter-spacing:.8px;margin-top:1px;}
.ee-greet-div{width:1px;background:rgba(255,255,255,.2);align-self:stretch;margin:4px 0;}
.ee-btn-white{background:#fff;color:#1E40AF;border:none;border-radius:8px;padding:9px 18px;font-size:13px;font-weight:600;cursor:pointer;font-family:'Outfit',sans-serif;display:inline-flex;align-items:center;gap:6px;transition:all .15s;box-shadow:0 2px 8px rgba(0,0,0,.15);}
.ee-btn-white:hover{box-shadow:0 4px 16px rgba(0,0,0,.2);transform:translateY(-1px);}

/* ── kpi ── */
.ee-kpi-row{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;}
.ee-kpi-row-3{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;}
.ee-kpi{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:16px 18px;display:flex;flex-direction:column;gap:2px;box-shadow:var(--shadow);transition:all .2s;cursor:pointer;}
.ee-kpi:hover{border-color:var(--border2);box-shadow:0 4px 20px rgba(0,0,0,.08);transform:translateY(-1px);}
.ee-kpi-top{display:flex;align-items:flex-start;justify-content:space-between;}
.ee-kpi-label{font-size:12px;color:var(--text2);font-weight:500;font-family:'DM Sans',sans-serif;}
.ee-kpi-icon{width:36px;height:36px;border-radius:9px;display:flex;align-items:center;justify-content:center;}
.ee-kpi-icon .ee-mi{font-size:19px;}
.ee-ki-blue{background:var(--accent-light);color:var(--accent);}
.ee-ki-green{background:var(--green-bg);color:var(--green);}
.ee-ki-amber{background:var(--amber-bg);color:var(--amber);}
.ee-ki-violet{background:var(--violet-bg);color:var(--violet);}
.ee-ki-red{background:var(--red-bg);color:var(--red);}
.ee-kpi-val{font-size:24px;font-weight:700;color:var(--text);margin-top:8px;}
.ee-kpi-sub{font-size:11px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif;}
.ee-trend-up{color:var(--green);}
.ee-trend-dn{color:var(--red);}

/* ── cards ── */
.ee-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:18px;box-shadow:var(--shadow);}
.ee-card-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}
.ee-card-title{font-size:14px;font-weight:600;color:var(--text);}
.ee-card-sub{font-size:12px;color:var(--text3);font-family:'DM Sans',sans-serif;}
.ee-two-col{display:grid;grid-template-columns:1.6fr 1fr;gap:16px;}
.ee-three-col{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px;}

/* ── page header ── */
.ee-page-hdr{display:flex;align-items:center;justify-content:space-between;}
.ee-page-title{font-size:20px;font-weight:700;color:var(--text);}
.ee-page-sub{font-size:13px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif;}

/* ── buttons ── */
.ee-btn{padding:8px 16px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);cursor:pointer;font-family:'Outfit',sans-serif;display:inline-flex;align-items:center;gap:6px;font-weight:500;transition:all .15s;}
.ee-btn:hover{background:var(--surface2);border-color:var(--border2);}
.ee-btn-primary{background:var(--accent);color:#fff;border-color:var(--accent);}
.ee-btn-primary:hover{background:#1D4ED8;}
.ee-btn-danger{background:var(--red);color:#fff;border-color:var(--red);}
.ee-btn-sm{padding:5px 12px;font-size:12px;}
.ee-btn-ghost{border:none;background:transparent;color:var(--text2);font-size:13px;cursor:pointer;font-family:'Outfit',sans-serif;padding:0;font-weight:500;}
.ee-btn-ghost:hover{color:var(--accent);}

/* ── filter bar ── */
.ee-filter-bar{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}
.ee-filter-select{padding:8px 12px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);font-family:'Outfit',sans-serif;cursor:pointer;outline:none;}
.ee-filter-select:focus{border-color:var(--accent);}
.ee-search-field{padding:8px 12px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);font-family:'Outfit',sans-serif;outline:none;min-width:200px;}
.ee-search-field:focus{border-color:var(--accent);}

/* ── table ── */
.ee-tbl-wrap{overflow-x:auto;overflow-y:auto;max-height:500px;border-radius:10px;border:1px solid var(--border);}
.ee-table{width:100%;border-collapse:collapse;font-family:'DM Sans',sans-serif;min-width:600px;}
.ee-pagination{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-top:1px solid var(--border);flex-shrink:0;}
.ee-pagination-info{font-size:12px;color:var(--text3);font-family:'DM Sans',sans-serif;}
.ee-pagination-btns{display:flex;align-items:center;gap:8px;}
.ee-pagination-page{font-size:12px;color:var(--text2);font-family:'DM Sans',sans-serif;min-width:80px;text-align:center;}
.ee-table thead th{background:var(--surface2);padding:10px 14px;text-align:left;font-size:11.5px;font-weight:600;color:var(--text2);text-transform:uppercase;letter-spacing:.5px;border-bottom:1px solid var(--border);position:sticky;top:0;z-index:2;}
.ee-table tbody td{padding:11px 14px;border-bottom:1px solid var(--border);font-size:13px;color:var(--text);vertical-align:middle;}
.ee-table tbody tr:last-child td{border-bottom:none;}
.ee-table tbody tr:hover td{background:var(--surface2);cursor:pointer;}
.ee-exp-id{font-family:'DM Sans',sans-serif;font-weight:600;color:var(--accent);}

/* ── pills ── */
.ee-pill{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;gap:5px;}
.ee-pill::before{content:'';width:6px;height:6px;border-radius:50%;flex-shrink:0;}
.ee-p-draft{background:#F1F5F9;color:#475569;}.ee-p-draft::before{background:#94A3B8;}
.ee-p-submitted{background:var(--violet-bg);color:var(--violet);}.ee-p-submitted::before{background:var(--violet);}
.ee-p-pending{background:var(--amber-bg);color:var(--amber);}.ee-p-pending::before{background:var(--amber);}
.ee-p-approved{background:var(--green-bg);color:var(--green);}.ee-p-approved::before{background:var(--green);}
.ee-p-rejected{background:var(--red-bg);color:var(--red);}.ee-p-rejected::before{background:var(--red);}
.ee-p-reimbursed{background:var(--accent-light);color:var(--accent);}.ee-p-reimbursed::before{background:var(--accent);}
.ee-p-info{background:#FFF7ED;color:#C2410C;}.ee-p-info::before{background:#C2410C;}

/* ── progress ── */
.ee-prog-wrap{background:#EEF0F8;border-radius:4px;height:6px;overflow:hidden;margin-top:5px;}
.ee-prog-fill{height:100%;border-radius:4px;transition:width .6s ease;}

/* ── timeline ── */
.ee-timeline{display:flex;flex-direction:column;gap:0;}
.ee-tl-item{display:flex;gap:12px;padding-bottom:16px;position:relative;}
.ee-tl-item:not(:last-child)::before{content:'';position:absolute;left:15px;top:28px;bottom:0;width:1px;background:var(--border);}
.ee-tl-dot{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;z-index:1;}
.ee-tl-dot .ee-mi{font-size:15px;}
.ee-td-green{background:var(--green-bg);color:var(--green);border:1.5px solid var(--green-bd);}
.ee-td-amber{background:var(--amber-bg);color:var(--amber);border:1.5px solid var(--amber-bd);}
.ee-td-blue{background:var(--accent-light);color:var(--accent);border:1.5px solid var(--accent-mid);}
.ee-td-violet{background:var(--violet-bg);color:var(--violet);border:1.5px solid var(--violet-bd);}
.ee-td-red{background:var(--red-bg);color:var(--red);border:1.5px solid var(--red-bd);}
.ee-tl-dot-grey{background:#F1F5F9;color:#94A3B8;border:1.5px solid #E2E8F0;}
.ee-tl-title{font-size:13px;font-weight:600;color:var(--text);}
.ee-tl-desc{font-size:12px;color:var(--text3);margin-top:1px;font-family:'DM Sans',sans-serif;}
.ee-tl-time{font-size:11px;color:var(--text3);margin-top:3px;font-family:'DM Sans',sans-serif;}

/* ── donut chart ── */
.ee-donut-wrap{display:flex;align-items:center;gap:20px;padding:4px 0;}
.ee-donut{width:88px;height:88px;border-radius:50%;flex-shrink:0;background:conic-gradient(var(--accent) 0deg 140deg,var(--green) 140deg 230deg,var(--amber) 230deg 290deg,var(--red) 290deg 360deg);position:relative;}
.ee-donut::after{content:'';position:absolute;inset:16px;background:var(--surface);border-radius:50%;}
.ee-legend{display:flex;flex-direction:column;gap:6px;}
.ee-leg-item{display:flex;align-items:center;gap:8px;font-size:12px;font-family:'DM Sans',sans-serif;}
.ee-leg-dot{width:9px;height:9px;border-radius:3px;flex-shrink:0;}
.ee-leg-lbl{color:var(--text2);}
.ee-leg-val{margin-left:auto;color:var(--text);font-weight:600;font-size:12px;}

/* ── quick actions ── */
.ee-qa-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}
.ee-qa-btn{background:var(--surface2);border:1px solid var(--border);border-radius:10px;padding:14px;display:flex;flex-direction:column;align-items:flex-start;gap:8px;cursor:pointer;transition:all .15s;}
.ee-qa-btn:hover{background:var(--accent-light);border-color:var(--accent-mid);}
.ee-qa-btn:hover .ee-qa-icon{background:var(--accent);color:#fff;}
.ee-qa-icon{width:34px;height:34px;border-radius:8px;background:#EEF0F8;display:flex;align-items:center;justify-content:center;color:var(--text2);transition:all .15s;}
.ee-qa-icon .ee-mi{font-size:18px;}
.ee-qa-label{font-size:12px;font-weight:600;color:var(--text);}
.ee-qa-desc{font-size:11px;color:var(--text3);font-family:'DM Sans',sans-serif;}

/* ── reimbursement card ── */
.ee-reimb-card{background:linear-gradient(135deg,#065F46,#059669);border-radius:12px;padding:16px;color:#fff;position:relative;overflow:hidden;}
.ee-reimb-card::after{content:'';position:absolute;bottom:-20px;right:-20px;width:100px;height:100px;background:rgba(255,255,255,.07);border-radius:50%;}
.ee-reimb-amount{font-size:26px;font-weight:700;margin:6px 0;}
.ee-reimb-lbl{font-size:11px;color:rgba(255,255,255,.65);text-transform:uppercase;letter-spacing:.8px;}
.ee-reimb-next{font-size:12px;color:rgba(255,255,255,.7);margin-top:8px;}

/* ── budget items ── */
.ee-budget-item{padding:10px 0;border-bottom:1px solid var(--border);}
.ee-budget-item:last-child{border-bottom:none;}
.ee-budget-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;}
.ee-budget-name{font-size:13px;font-weight:500;color:var(--text);}
.ee-budget-pct{font-size:12px;font-weight:600;}

/* ── alert strip ── */
.ee-alert{border-radius:9px;padding:11px 14px;display:flex;align-items:center;gap:10px;font-size:13px;font-family:'DM Sans',sans-serif;}
.ee-alert .ee-mi{font-size:18px;flex-shrink:0;}
.ee-a-amber{background:var(--amber-bg);color:var(--amber);border:1px solid var(--amber-bd);}
.ee-a-red{background:var(--red-bg);color:var(--red);border:1px solid var(--red-bd);}
.ee-a-blue{background:var(--accent-light);color:var(--accent);border:1px solid var(--accent-mid);}
.ee-a-green{background:var(--green-bg);color:var(--green);border:1px solid var(--green-bd);}

/* ── info banner ── */
.ee-info-banner{background:var(--accent-light);border:1px solid var(--accent-mid);border-radius:10px;padding:14px 16px;font-size:13px;color:var(--accent);display:flex;gap:10px;align-items:flex-start;font-family:'DM Sans',sans-serif;}
.ee-info-banner .ee-mi{font-size:20px;flex-shrink:0;margin-top:1px;}

/* ── approval pipeline ── */
.ee-approval-track{display:flex;align-items:center;gap:0;}
.ee-apv-step{flex:1;text-align:center;}
.ee-apv-circle{width:36px;height:36px;border-radius:50%;margin:0 auto 8px;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;}
.ee-asc-done{background:var(--green-bg);color:var(--green);border:2px solid var(--green);}
.ee-asc-active{background:var(--amber-bg);color:var(--amber);border:2px solid var(--amber);}
.ee-asc-pending{background:#F1F5F9;color:#94A3B8;border:2px solid #E2E8F0;}
.ee-apv-connector{width:60px;height:2px;background:var(--border);align-self:center;flex-shrink:0;}
.ee-apv-connector-done{background:var(--green);}
.ee-apv-label{font-size:11px;color:var(--text2);font-weight:600;}
.ee-apv-sub{font-size:10px;color:var(--text3);font-family:'DM Sans',sans-serif;margin-top:2px;}

/* ── bar chart ── */
.ee-bar-chart{display:flex;align-items:flex-end;gap:10px;height:140px;padding:10px 0;}
.ee-bar-wrap{flex:1;display:flex;flex-direction:column;align-items:center;gap:4px;}
.ee-bar{width:100%;border-radius:6px 6px 0 0;transition:height .5s ease;cursor:pointer;}
.ee-bar:hover{opacity:.85;}
.ee-bar-lbl{font-size:10px;color:var(--text3);font-family:'DM Sans',sans-serif;}
.ee-bar-amt{font-size:9px;color:var(--text3);font-family:'DM Sans',sans-serif;font-weight:600;}

/* ── settings ── */
.ee-settings-row{display:flex;align-items:center;justify-content:space-between;padding:14px 0;border-bottom:1px solid var(--border);}
.ee-settings-row:last-child{border-bottom:none;}
.ee-settings-row-left h4{font-size:14px;font-weight:500;color:var(--text);}
.ee-settings-row-left p{font-size:12px;color:var(--text3);margin-top:3px;font-family:'DM Sans',sans-serif;}
.ee-toggle-wrap{position:relative;width:40px;height:22px;cursor:pointer;}
.ee-toggle-track{width:40px;height:22px;border-radius:11px;background:#CBD5E1;transition:background .2s;position:absolute;inset:0;}
.ee-toggle-track.on{background:var(--accent);}
.ee-toggle-thumb{position:absolute;top:3px;left:3px;width:16px;height:16px;background:#fff;border-radius:50%;transition:transform .2s;box-shadow:0 1px 4px rgba(0,0,0,.2);}
.ee-toggle-thumb.on{transform:translateX(18px);}

/* ── modal ── */
.ee-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9000;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(2px);}
.ee-modal{background:#fff;border-radius:16px;width:640px;max-width:95vw;max-height:88vh;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.25);animation:ee-modal-in .18s ease;}
.ee-modal-lg{width:760px;}
.ee-modal-sm{width:440px;}
@keyframes ee-modal-in{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
.ee-spinner-wrap{display:flex;align-items:center;justify-content:center;flex:1;min-height:320px;flex-direction:column;gap:14px;}
.ee-spinner{width:40px;height:40px;border:3px solid var(--border2);border-top-color:var(--accent);border-radius:50%;animation:ee-spin .65s linear infinite;}
@keyframes ee-spin{to{transform:rotate(360deg)}}
.ee-spinner-label{font-size:13px;color:var(--text3);font-family:'DM Sans',sans-serif;}
.ee-modal-head{padding:20px 24px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.ee-modal-title{font-size:16px;font-weight:700;color:var(--text);}
.ee-modal-close{width:32px;height:32px;border-radius:8px;border:1px solid var(--border);background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text3);font-size:18px;}
.ee-modal-close:hover{background:var(--surface2);}
.ee-modal-body{padding:24px;overflow-y:auto;flex:1;}
.ee-modal-foot{padding:16px 24px;border-top:1px solid var(--border);display:flex;justify-content:flex-end;gap:10px;flex-shrink:0;}

/* ── form ── */
.ee-form-group{margin-bottom:16px;}
.ee-form-label{display:block;font-size:13px;font-weight:600;color:var(--text2);margin-bottom:6px;}
.ee-req{color:var(--red);}
.ee-form-input,.ee-form-select,.ee-form-textarea{width:100%;padding:9px 12px;border-radius:8px;border:1.5px solid var(--border);font-size:13px;font-family:'Outfit',sans-serif;color:var(--text);background:var(--surface);outline:none;transition:border-color .15s;}
.ee-form-input:focus,.ee-form-select:focus,.ee-form-textarea:focus{border-color:var(--accent);}
.ee-form-textarea{resize:vertical;min-height:80px;}
.ee-form-row{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
.ee-form-row-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px;}
.ee-form-input-ro{background:var(--surface2);cursor:default;}
.ee-upload-zone{border:2px dashed var(--border2);border-radius:10px;padding:24px;text-align:center;cursor:pointer;transition:all .15s;}
.ee-upload-zone:hover{border-color:var(--accent);background:var(--accent-light);}
.ee-upload-zone .ee-mi{font-size:36px;color:var(--text3);}
.ee-upload-zone p{font-size:13px;color:var(--text3);margin-top:8px;font-family:'DM Sans',sans-serif;}
.ee-upload-hint{font-size:11px;color:var(--text3);margin-top:4px;}

/* ── detail view ── */
.ee-detail-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;}
.ee-detail-field{padding:10px 14px;background:var(--surface2);border-radius:8px;border:1px solid var(--border);}
.ee-detail-field-label{font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.5px;font-family:'DM Sans',sans-serif;font-weight:600;}
.ee-detail-field-value{font-size:14px;color:var(--text);font-weight:600;margin-top:4px;}
.ee-detail-full{grid-column:1/-1;}

/* ── notif panel ── */
.ee-notif-panel{position:absolute;top:42px;right:0;width:320px;background:var(--surface);border:1px solid var(--border);border-radius:14px;box-shadow:0 8px 30px rgba(0,0,0,.12);z-index:500;overflow:hidden;}
.ee-notif-head{padding:14px 16px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;}
.ee-notif-head-title{font-size:14px;font-weight:600;color:var(--text);}
.ee-notif-item{padding:12px 16px;border-bottom:1px solid var(--border);cursor:pointer;display:flex;gap:10px;transition:background .15s;}
.ee-notif-item:hover{background:var(--surface2);}
.ee-notif-item:last-child{border-bottom:none;}
.ee-notif-unread{background:var(--accent-light);}
.ee-notif-icon{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
.ee-notif-msg{font-size:12.5px;color:var(--text);line-height:1.4;}
.ee-notif-time{font-size:11px;color:var(--text3);margin-top:3px;font-family:'DM Sans',sans-serif;}
`;

/* ─── Helpers (data) ───────────────────────────────────────── */
const getUserName = () => {
  try { return JSON.parse(localStorage.getItem("user") || "{}").name || localStorage.getItem("name") || "there"; } catch { return "there"; }
};

const fmtAmt = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
const YEAR_OPTIONS = Array.from({ length: new Date().getFullYear() - 2023 }, (_, i) => new Date().getFullYear() - i);
const PAGE_SIZE = 20;

const fmtDate = (d) => {
  if (!d) return "";
  // ISO "2026-05-12" → "12 May 2026"
  if (/^\d{4}-\d{2}-\d{2}/.test(String(d))) {
    const [y, m, day] = String(d).split("T")[0].split("-");
    const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${parseInt(day)} ${MONTHS[parseInt(m) - 1]} ${y}`;
  }
  return d; // already formatted
};

// Backend status field values: "Pending L1", "Pending L2", "Info Requested",
// "Approved", "Reimbursed", "Rejected", "Draft"
// statusLabel values: "Pending Manager Approval", "Pending Admin Approval",
// "Info Requested", "Approved", "Reimbursed", "Rejected", "Draft"
const PILL_CLASS = {
  "Pending L1": "ee-p-pending",
  "Pending L2": "ee-p-pending",
  "Info Requested": "ee-p-info",
  "Approved": "ee-p-approved",
  "Reimbursed": "ee-p-reimbursed",
  "Rejected": "ee-p-rejected",
  "Draft": "ee-p-draft",
  "Pending Manager Approval": "ee-p-pending",
  "Pending Admin Approval": "ee-p-pending",
};

// True if expense is in any pending/in-progress state (not final)
const isPendingStatus = (s) => ["Pending L1", "Pending L2", "Info Requested"].includes(s);
const isInfoStatus = (s) => s === "Info Requested";
const isApprovedStatus = (s) => s === "Approved";
const isReimbursedStatus = (s) => s === "Reimbursed";
const isRejectedStatus = (s) => s === "Rejected";
const isDraftStatus = (s) => s === "Draft" || !s;

/* ─── Helpers ─────────────────────────────────────────────── */
const Mi = ({ icon, style }) => <span className="ee-mi" style={style}>{icon}</span>;

function Toggle({ on, onToggle }) {
  return (
    <div className="ee-toggle-wrap" onClick={onToggle}>
      <div className={`ee-toggle-track${on ? " on" : ""}`} />
      <div className={`ee-toggle-thumb${on ? " on" : ""}`} />
    </div>
  );
}

/* ─── Sidebar ─────────────────────────────────────────────── */
function Sidebar({ active, onNav, onModal, expenses, intPermission }) {
  const arr = expenses || [];
  const pendingBadge = arr.filter(e => isPendingStatus(e.status)).length;
  const actionBadge = arr.filter(e => isInfoStatus(e.status)).length;

  return (
    <aside className="ee-sidebar">
      <div className="ee-brand">
        <div className="ee-brand-logo">
          <div className="ee-brand-icon"><Mi icon="account_balance_wallet" /></div>
          <div>
            <div className="ee-brand-name">Balsuite</div>
            <div className="ee-brand-tag">Expense Management</div>
          </div>
        </div>
      </div>
      <div className="ee-nav-scroll">
        <div className="ee-nav-section">Overview</div>
        {[
          { key: "dashboard", icon: "dashboard", label: "My Dashboard" },
          { key: "my-expenses", icon: "receipt_long", label: "My Expenses", badge: actionBadge > 0 ? String(actionBadge) : null },
          { key: "my-claims", icon: "folder_open", label: "My Claims" },
        ].map((item) => (
          <div key={item.key} className={`ee-nav-item${active === item.key ? " active" : ""}`} onClick={() => onNav(item.key)}>
            <Mi icon={item.icon} />{item.label}
            {item.badge && <span className="ee-nav-badge">{item.badge}</span>}
          </div>
        ))}

        <div className="ee-nav-section">Actions</div>
        {[
          // { modal: "new-expense", icon: "add_circle_outline", label: "Submit Expense" },
          { modal: "upload", icon: "cloud_upload", label: "Upload Receipt" },
        ].map((item) => (
          <div key={item.modal} className="ee-nav-item" onClick={() => onModal(item.modal)}>
            <Mi icon={item.icon} />{item.label}
          </div>
        ))}

        <div className="ee-nav-section">Tracking</div>
        {[
          { key: "pending-approvals", icon: "hourglass_empty", label: "Pending Approvals", badge: pendingBadge > 0 ? String(pendingBadge) : null, green: true },
          { key: "reimbursements", icon: "payments", label: "Reimbursements" },
          { key: "spend-analytics", icon: "bar_chart", label: "Spend Analytics" },
          ...(intPermission?.active ? [{ key: "internal-expenses", icon: "business_center", label: "Internal Expenses" }] : []),
        ].map((item) => (
          <div key={item.key} className={`ee-nav-item${active === item.key ? " active" : ""}`} onClick={() => onNav(item.key)}>
            <Mi icon={item.icon} />{item.label}
            {item.badge && <span className={`ee-nav-badge${item.green ? " ee-nav-badge-green" : ""}`}>{item.badge}</span>}
          </div>
        ))}
      </div>
      <div className="ee-sidebar-foot">
        <div className="ee-nav-item foot-item" onClick={() => onNav("settings")}><Mi icon="settings" />Settings</div>
      </div>
    </aside>
  );
}

/* ─── Topbar ──────────────────────────────────────────────── */
const PAGE_TITLES = {
  "dashboard": "Expense Dashboard", "my-expenses": "My Expenses",
  "my-claims": "My Claims", "pending-approvals": "Pending Approvals",
  "reimbursements": "Reimbursements", "spend-analytics": "Spend Analytics",
  "internal-expenses": "Internal Expenses", "settings": "Settings",
};

const NOTIFS = [
  { bg: "var(--amber-bg)", ic: "schedule", icColor: "var(--amber)", msg: "EXP-2026-00014 is pending L1 approval from Ravi Sharma.", time: "Today · 10:22 AM", unread: true },
  { bg: "var(--accent-light)", ic: "info", icColor: "var(--accent)", msg: "Clarification requested on EXP-2026-00012 – please add hotel invoice.", time: "Yesterday · 3:45 PM", unread: true },
  { bg: "var(--green-bg)", ic: "payments", icColor: "var(--green)", msg: "₹8,750 reimbursed to your HDFC account ••••4521.", time: "May 5 · 9:00 AM", unread: false },
  { bg: "var(--amber-bg)", ic: "warning_amber", icColor: "var(--amber)", msg: "Meals & Entertainment budget at 90% – ₹200 remaining.", time: "May 12 · 8:00 AM", unread: false },
];

function Topbar({ active, notifOpen, setNotifOpen }) {
  return (
    <div className="ee-topbar">
      <Mi icon="home" style={{ color: "var(--text3)", fontSize: 18, cursor: "pointer" }} />
      <span style={{ color: "var(--text3)", margin: "0 4px", fontSize: 13 }}>›</span>
      <span className="ee-topbar-title">{PAGE_TITLES[active] || active}</span>
      <div className="ee-topbar-right">
        <div className="ee-icon-btn">
          <Mi icon="search" style={{ fontSize: 18 }} />
        </div>
        {/* <div style={{ position: "relative" }}>
          <div className="ee-icon-btn" onClick={() => setNotifOpen((v) => !v)}>
            <Mi icon="notifications" style={{ fontSize: 18 }} />
            <span className="ee-notif-dot" />
          </div>
          {notifOpen && (
            <div className="ee-notif-panel">
              <div className="ee-notif-head">
                <span className="ee-notif-head-title">Notifications</span>
                <button className="ee-btn-ghost" style={{ fontSize: 12 }} onClick={() => toast.success("All marked as read")}>Mark all read</button>
              </div>
              {NOTIFS.map((n, i) => (
                <div key={i} className={`ee-notif-item${n.unread ? " ee-notif-unread" : ""}`}>
                  <div className="ee-notif-icon" style={{ background: n.bg }}>
                    <Mi icon={n.ic} style={{ fontSize: 17, color: n.icColor }} />
                  </div>
                  <div>
                    <div className="ee-notif-msg">{n.msg}</div>
                    <div className="ee-notif-time">{n.time}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div> */}
        <div className="ee-icon-btn">
          <Mi icon="help_outline" style={{ fontSize: 18 }} />
        </div>
        {/* <div className="ee-top-av">AK</div> */}
      </div>
    </div>
  );
}

/* ─── Page: Dashboard ─────────────────────────────────────── */
function DashboardPage({ onNav, onModal, myDashboard, stats }) {
  const recent = myDashboard?.recentExpenses || [];
  const infoExpenses = myDashboard?.infoExpenses || [];

  const hour = new Date().getHours();
  const greetWord = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const userName = getUserName();

  const pendingCount = Number(stats?.pendingApproval || 0);
  const pendingReimbAmount = Number(myDashboard?.approvedPendingAmount || 0);
  const reimbursedYTD = Number(stats?.reimbursedYTD || 0);
  const totalAmount = Number(myDashboard?.totalAmount || 0);
  const totalExpenses = Number(myDashboard?.totalExpenses || 0);
  const totalFiled = Number(myDashboard?.totalFiled || 0);
  const rejectedCount = Number(myDashboard?.rejectedCount || 0);
  const approvedCount = Number(myDashboard?.approvedCount || 0);
  const approvalRate = totalFiled > 0 ? Math.round(((totalFiled - rejectedCount) / totalFiled) * 100) : 100;

  // Category totals for donut (pre-computed by backend)
  const catColors = ["var(--accent)", "var(--green)", "var(--amber)", "var(--red)"];
  const topCats = (myDashboard?.categoryBreakdown || []).map(c => [c.category, Number(c.total)]);
  const catTotal = topCats.reduce((s, [, v]) => s + v, 0);
  const donutGradient = topCats.length > 0 ? (() => {
    let deg = 0;
    return `conic-gradient(${topCats.map(([, v], i) => {
      const pct = catTotal > 0 ? (v / catTotal) * 360 : 0;
      const seg = `${catColors[i]} ${deg}deg ${deg + pct}deg`;
      deg += pct;
      return seg;
    }).join(",")})`;
  })() : "conic-gradient(var(--border) 0deg 360deg)";

  // Timeline from recent expenses (top 5 of the 6 returned)
  const timelineItems = recent.slice(0, 5).map(e => {
    const s = e.status || "";
    if (isReimbursedStatus(s)) return { dotCls: "ee-td-green", icon: "payments", title: "Reimbursement Processed", desc: `${e.id} – ${fmtAmt(e.amount)}`, time: fmtDate(e.date) };
    if (isApprovedStatus(s)) return { dotCls: "ee-td-green", icon: "check_circle", title: "Expense Approved", desc: `${e.id} – ${e.category}`, time: fmtDate(e.date) };
    if (isRejectedStatus(s)) return { dotCls: "ee-td-red", icon: "cancel", title: "Expense Rejected", desc: `${e.id} – ${e.rejectionReason || "Please resubmit"}`, time: fmtDate(e.date) };
    if (isInfoStatus(s)) return { dotCls: "ee-td-blue", icon: "info", title: "Clarification Requested", desc: `${e.id} – ${e.infoRequestMessage || "Info needed"}`, time: fmtDate(e.date) };
    if (isPendingStatus(s)) return { dotCls: "ee-td-amber", icon: "schedule", title: "Approval Pending", desc: `${e.id} – ${e.title}`, time: fmtDate(e.date) };
    return { dotCls: "ee-tl-dot-grey", icon: "edit", title: "Draft Saved", desc: `${e.id} – ${e.title}`, time: fmtDate(e.date) };
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div className="ee-greet">
        <div className="ee-greet-text" style={{ zIndex: 1 }}>
          <h2>{greetWord}, {userName} 👋</h2>
          <p>{pendingCount > 0
            ? `You have ${pendingCount} expense${pendingCount > 1 ? "s" : ""} awaiting approval${pendingReimbAmount > 0 ? ` and ${fmtAmt(pendingReimbAmount)} pending reimbursement` : ""}.`
            : pendingReimbAmount > 0 ? `You have ${fmtAmt(pendingReimbAmount)} pending reimbursement.` : "All caught up! No pending expenses."}</p>
          <button className="ee-btn-white" style={{ marginTop: 14 }} onClick={() => onModal("new-expense")}>
            <Mi icon="add" style={{ fontSize: 16 }} /> New Expense
          </button>
        </div>
        <div className="ee-greet-stats">
          <div className="ee-greet-stat"><div className="ee-greet-stat-val">{fmtAmt(totalAmount)}</div><div className="ee-greet-stat-lbl">Total This Year</div></div>
          <div className="ee-greet-div" />
          <div className="ee-greet-stat"><div className="ee-greet-stat-val">{totalExpenses}</div><div className="ee-greet-stat-lbl">Expenses Filed</div></div>
          <div className="ee-greet-div" />
          <div className="ee-greet-stat"><div className="ee-greet-stat-val">{approvalRate}%</div><div className="ee-greet-stat-lbl">Approval Rate</div></div>
        </div>
      </div>

      <div className="ee-kpi-row">
        {[
          { label: "Pending Approvals", val: String(pendingCount), sub: pendingCount > 0 ? `${pendingCount} expense${pendingCount > 1 ? "s" : ""} in review` : "All clear", icon: "hourglass_top", cls: "ee-ki-amber", page: "pending-approvals" },
          { label: "Pending Reimbursement", val: fmtAmt(pendingReimbAmount), sub: `${stats?.approvedPendingReimb ?? 0} approved · awaiting payment`, icon: "account_balance_wallet", cls: "ee-ki-violet", page: "reimbursements" },
          { label: "Reimbursed (YTD)", val: fmtAmt(reimbursedYTD), sub: "Year to date", icon: "check_circle", cls: "ee-ki-green", page: "reimbursements" },
          { label: "Total This Month", val: fmtAmt(stats?.totalThisMonth || 0), sub: null, icon: "donut_large", cls: "ee-ki-blue", page: "spend-analytics" },
        ].map((k) => (
          <div key={k.label} className="ee-kpi" onClick={() => onNav(k.page)}>
            <div className="ee-kpi-top">
              <span className="ee-kpi-label">{k.label}</span>
              <div className={`ee-kpi-icon ${k.cls}`}><Mi icon={k.icon} /></div>
            </div>
            <div className="ee-kpi-val" style={{ fontSize: k.val.length > 8 ? 16 : 24 }}>{k.val}</div>
            {k.sub && <div className="ee-kpi-sub">{k.sub}</div>}
          </div>
        ))}
      </div>

      <div className="ee-two-col">
        <div className="ee-card">
          <div className="ee-card-head">
            <div><div className="ee-card-title">Recent Expenses</div><div className="ee-card-sub">Latest {recent.length} of {totalExpenses} total</div></div>
            <button className="ee-btn ee-btn-sm ee-btn-primary" onClick={() => onModal("new-expense")}><Mi icon="add" style={{ fontSize: 14 }} />New</button>
          </div>
          <div className="ee-tbl-wrap">
            <table className="ee-table">
              <thead><tr><th>Expense </th><th>Category</th><th>Date</th><th>Amount</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {recent.length === 0 && <tr><td colSpan={6} style={{ textAlign: "center", color: "var(--text3)", padding: 24 }}>No expenses yet</td></tr>}
                {recent.map((e) => (
                  <tr key={e.id}>
                    <td><span className="ee-exp-id">{e.id}</span></td>
                    <td>{e.category}</td>
                    <td>{fmtDate(e.date)}</td>
                    <td style={{ fontWeight: 600 }}>{fmtAmt(e.amount)}</td>
                    <td><span className={`ee-pill ${PILL_CLASS[e.status] || "ee-p-draft"}`}>{e.statusLabel || e.status}</span></td>
                    <td>
                      <button className="ee-btn-ghost" onClick={() => onModal("view-expense", e)}>
                        {isInfoStatus(e.status) ? "Respond" : isRejectedStatus(e.status) ? "Resubmit" : "View"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", borderTop: "1px solid var(--border)" }}>
            <span style={{ fontSize: 12, color: "var(--text3)", fontFamily: "DM Sans,sans-serif" }}>Showing {recent.length} of {totalExpenses} expenses</span>
            <button className="ee-btn-ghost" style={{ fontSize: 12 }} onClick={() => onNav("my-expenses")}>View All Expenses →</button>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="ee-card">
            <div className="ee-card-head"><div className="ee-card-title">Quick Actions</div></div>
            <div className="ee-qa-grid">
              {[
                { icon: "add_circle", label: "New Expense", desc: "Submit a single receipt", action: () => onModal("new-expense") },
                // { icon: "picture_as_pdf", label: "Download Slip", desc: "Get reimbursement PDF", action: () => toast.info("Downloading reimbursement slip...") },
                { icon: "bar_chart", label: "Spend Analytics", desc: "View expense patterns", action: () => onNav("spend-analytics") },
              ].map((q) => (
                <div key={q.label} className="ee-qa-btn" onClick={q.action}>
                  <div className="ee-qa-icon"><Mi icon={q.icon} /></div>
                  <div className="ee-qa-label">{q.label}</div>
                  <div className="ee-qa-desc">{q.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="ee-reimb-card">
            <div className="ee-reimb-lbl">Total Reimbursed (YTD)</div>
            <div className="ee-reimb-amount">{fmtAmt(reimbursedYTD)}</div>
            <div className="ee-reimb-next">Next cycle: <strong style={{ color: "#fff" }}>end of month</strong></div>
          </div>
        </div>
      </div>

      <div className="ee-three-col">
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Category Breakdown</div><button className="ee-btn-ghost" style={{ fontSize: 12 }} onClick={() => onNav("spend-analytics")}>See Full →</button></div>
          {topCats.length > 0 ? (
            <div className="ee-donut-wrap">
              <div className="ee-donut" style={{ background: donutGradient }} />
              <div className="ee-legend">
                {topCats.map(([cat, amt], i) => (
                  <div key={cat} className="ee-leg-item">
                    <div className="ee-leg-dot" style={{ background: catColors[i] }} />
                    <span className="ee-leg-lbl">{cat}</span>
                    <span className="ee-leg-val">{fmtAmt(amt)}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : <div style={{ textAlign: "center", color: "var(--text3)", padding: "20px 0", fontSize: 13 }}>No expense data yet</div>}
        </div>

        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Expense Summary</div></div>
          {[
            { label: "Submitted", val: totalFiled, color: "var(--accent)" },
            { label: "Approved / Reimbursed", val: approvedCount, color: "var(--green)" },
            { label: "Pending Approval", val: pendingCount, color: "var(--amber)" },
            { label: "Rejected", val: rejectedCount, color: "var(--red)" },
          ].map(b => (
            <div key={b.label} className="ee-budget-item">
              <div className="ee-budget-top"><span className="ee-budget-name">{b.label}</span><span className="ee-budget-pct" style={{ color: b.color }}>{b.val}</span></div>
              <div className="ee-prog-wrap"><div className="ee-prog-fill" style={{ width: totalExpenses > 0 ? `${(b.val / totalExpenses) * 100}%` : "0%", background: b.color }} /></div>
            </div>
          ))}
        </div>

        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Recent Activity</div></div>
          <div className="ee-timeline">
            {timelineItems.length === 0 && <div style={{ textAlign: "center", color: "var(--text3)", padding: "20px 0", fontSize: 13 }}>No activity yet</div>}
            {timelineItems.map((t, i) => (
              <div key={i} className="ee-tl-item">
                <div className={`ee-tl-dot ${t.dotCls}`}><Mi icon={t.icon} /></div>
                <div><div className="ee-tl-title">{t.title}</div><div className="ee-tl-desc">{t.desc}</div><div className="ee-tl-time">{t.time}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {(infoExpenses.length > 0 || pendingCount > 0) && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {infoExpenses.map(e => (
            <div key={e.id} className="ee-alert ee-a-amber">
              <Mi icon="warning_amber" />
              <span>Your expense <strong>{e.id}</strong> requires clarification. <span style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => onModal("view-expense", e)}>Respond now →</span></span>
            </div>
          ))}
          {pendingCount > 0 && infoExpenses.length === 0 && (
            <div className="ee-alert ee-a-blue"><Mi icon="info" /><span>You have <strong>{pendingCount}</strong> expense{pendingCount > 1 ? "s" : ""} in the approval pipeline.</span></div>
          )}
        </div>
      )}
    </div>
  );
}

/* ─── Slip download (jsPDF) ───────────────────────────────── */
const downloadSlip = (expense) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;

  const dark = [24, 25, 42];
  const muted = [100, 102, 120];
  const border = [220, 222, 232];
  const blue = [37, 99, 235];
  const green = [22, 163, 74];
  const violet = [124, 58, 237];

  // ── helpers ──────────────────────────────────────────────
  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);

  const hline = (y) => {
    dc(border);
    doc.setLineWidth(0.3);
    doc.line(margin, y, W - margin, y);
  };

  // ── Header ───────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  tc(blue);
  doc.text("Balsuite ", margin, 22);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  tc(muted);
  doc.text("Expense Reimbursement Slip", margin, 28);

  doc.setFont("courier", "normal");
  doc.setFontSize(9);
  tc(blue);
  doc.text(expense.id || "—", W - margin, 22, { align: "right" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });

  hline(34);

  // ── Amount ───────────────────────────────────────────────
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  tc(muted);
  doc.text("Amount reimbursed", margin, 44);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  tc(green);
  doc.text(`Rs. ${Number(expense.amount).toLocaleString("en-IN")}`, margin, 56);

  hline(63);

  // ── Borderless 2-column fields ────────────────────────────
  const fields = [
    ["Employee", expense.employee || "—"],
    // ["Employee ID",     expense.empId          || "—"],
    ["Department", expense.dept || "—"],
    ["Category", expense.category || "—"],
    ["Expense date", fmtDate(expense.date)],
    ["Payment mode", expense.payment || "—"],
    ["Transaction ref", expense.transactionRef || "—"],
    ["Reimbursed on", fmtDate(expense.reimbursedAt) || fmtDate(expense.updatedAt) || "—"],
    ["Status", "Reimbursed"],
  ];

  const colW = cW / 2;
  const cellH = 14;
  let y = 70;

  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col];
      if (!f) return;
      const x = margin + col * colW;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      tc(muted);
      doc.text(f[0], x, y);

      const isStatus = f[0] === "Status";
      const isTxn = f[0] === "Transaction ref";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      tc(isStatus ? green : isTxn ? violet : dark);
      doc.text(String(f[1]), x, y + 7);
    });

    y += cellH;
  }

  hline(y + 4);

  // ── Footer ───────────────────────────────────────────────
  const genDate = new Date().toLocaleDateString("en-IN", {
    day: "numeric", month: "long", year: "numeric",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  tc(muted);
  doc.text(
    `Generated ${genDate}  ·  Balsuite Expense Management System`,
    W / 2, y + 11, { align: "center" }
  );

  doc.save(`slip-${expense.id}.pdf`);
};


/* ─── Page: My Expenses ─────────────────────────────────────── */
function MyExpensesPage({ onModal, expenses, onRefresh }) {
  const [search, setSearch] = useState("");
  const [statusF, setStatusF] = useState("");
  const [catF, setCatF] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);

  const arr = expenses || [];
  const uniqueCats = [...new Set(arr.map(e => e.category).filter(Boolean))].sort();

  const filtered = arr.filter((e) => {
    const txt = `${e.id} ${e.title} ${e.category}`.toLowerCase();
    const statusMatch = !statusF || (() => {
      if (statusF === "Pending") return isPendingStatus(e.status);
      if (statusF === "Info") return isInfoStatus(e.status);
      if (statusF === "Approved") return isApprovedStatus(e.status);
      if (statusF === "Reimbursed") return isReimbursedStatus(e.status);
      if (statusF === "Rejected") return isRejectedStatus(e.status);
      if (statusF === "Draft") return isDraftStatus(e.status);
      return true;
    })();
    return (!search || txt.includes(search.toLowerCase())) && statusMatch && (!catF || e.category === catF);
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">My Expenses</div><div className="ee-page-sub">All your submitted expenses in one place</div></div>
        <button className="ee-btn ee-btn-primary" onClick={() => onModal("new-expense")}><Mi icon="add" style={{ fontSize: 15 }} /> New Expense</button>
      </div>
      <div className="ee-filter-bar">
        <select className="ee-filter-select" value={statusF} onChange={(e) => { setStatusF(e.target.value); setPage(0); }}>
          <option value="">All Statuses</option>
          <option value="Pending">Pending Approval</option>
          <option value="Info">Info Requested</option>
          <option value="Approved">Approved</option>
          <option value="Reimbursed">Reimbursed</option>
          <option value="Rejected">Rejected</option>
          <option value="Draft">Draft</option>
        </select>
        <select className="ee-filter-select" value={catF} onChange={(e) => { setCatF(e.target.value); setPage(0); }}>
          <option value="">All Categories</option>
          {uniqueCats.map(c => <option key={c}>{c}</option>)}
        </select>
        <select className="ee-filter-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <input className="ee-search-field" placeholder="Search by expense # or title..." value={search} onChange={(e) => { setSearch(e.target.value); setPage(0); }} />
        <button className="ee-btn" onClick={() => toast.success("Exported to Excel!")}><Mi icon="file_download" style={{ fontSize: 15 }} />Export</button>
      </div>
      <div className="ee-card" style={{ padding: 0 }}>
        <div className="ee-tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table className="ee-table">
            <thead><tr><th>Expense </th><th>Title / Category</th><th>Date</th><th>Amount</th><th>Payment</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {filtered.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--text3)", padding: 28 }}>No expenses found</td></tr>}
              {filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((e) => (
                <tr key={e.id}>
                  <td><span className="ee-exp-id">{e.id}</span></td>
                  <td>
                    <div style={{ fontWeight: 500 }}>{e.title}</div>
                    <div style={{ fontSize: 11, color: "var(--text3)" }}>{e.category}</div>
                  </td>
                  <td>{fmtDate(e.date)}</td>
                  <td style={{ fontWeight: 600 }}>{fmtAmt(e.amount)}</td>
                  <td>{e.payment}</td>
                  <td><span className={`ee-pill ${PILL_CLASS[e.status] || "ee-p-draft"}`}>{e.statusLabel || e.status}</span></td>
                  <td>
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      <button className="ee-btn ee-btn-sm" onClick={() => onModal("view-expense", e)}>View</button>
                      {isReimbursedStatus(e.status) && (
                        <button className="ee-btn ee-btn-sm ee-btn-primary" onClick={() => downloadSlip(e)}>
                          <Mi icon="download" style={{ fontSize: 13 }} />Slip
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="ee-pagination">
          <span className="ee-pagination-info">
            {filtered.length === 0 ? "0 expenses" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, filtered.length)} of ${filtered.length}`}
          </span>
          <div className="ee-pagination-btns">
            <button className="ee-btn ee-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="ee-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))}</span>
            <button className="ee-btn ee-btn-sm" disabled={page >= Math.ceil(filtered.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Page: My Claims ─────────────────────────────────────── */
function MyClaimsPage({ onModal, claims, onRefresh }) {
  const [statusF, setStatusF] = useState("");
  const [search, setSearch] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const arr = claims || [];
  const filtered = arr.filter(c => {
    const txt = `${c.id} ${c.title}`.toLowerCase();
    return (!search || txt.includes(search.toLowerCase()))
      && (!statusF || (c.statusLabel || "").toLowerCase().includes(statusF.toLowerCase()));
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">My Claims</div><div className="ee-page-sub">Grouped expense submissions for reimbursement</div></div>
      </div>
      <div className="ee-filter-bar">
        <select className="ee-filter-select" value={statusF} onChange={e => { setStatusF(e.target.value); setPage(0); }}>
          <option value="">All Statuses</option>
          <option>Draft</option><option>Submitted</option><option>Pending</option><option>Approved</option><option>Reimbursed</option>
        </select>
        <select className="ee-filter-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <input className="ee-search-field" placeholder="Search by claim #..." value={search} onChange={e => { setSearch(e.target.value); setPage(0); }} />
      </div>
      <div className="ee-card" style={{ padding: 0 }}>
        <div className="ee-tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table className="ee-table">
            <thead><tr><th>Claim Id</th><th>Title</th><th>Period</th><th style={{ textAlign: "center" }}>Expenses</th><th>Total</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {filtered.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--text3)", padding: 24 }}>No claims found</td></tr>}
              {filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((c) => (
                <tr key={c.id}>
                  <td><span className="ee-exp-id">{c.id}</span></td>
                  <td style={{ fontWeight: 500 }}>{c.title}</td>
                  <td>{c.period}</td>
                  <td style={{ textAlign: "center" }}>{c.items}</td>
                  <td style={{ fontWeight: 600 }}>{fmtAmt(c.total)}</td>
                  <td><span className={`ee-pill ${PILL_CLASS[c.statusLabel] || PILL_CLASS[c.status] || "ee-p-draft"}`}>{c.statusLabel}</span></td>
                  <td>
                    {(c.statusLabel === "Reimbursed" || isReimbursedStatus(c.status))
                      ? <button className="ee-btn ee-btn-sm ee-btn-primary" onClick={() => downloadClaimSlip(c)}><Mi icon="download" style={{ fontSize: 13 }} /> Slip</button>
                      : <button className="ee-btn ee-btn-sm" onClick={() => onModal("view-claim", c)}>View</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="ee-pagination">
          <span className="ee-pagination-info">
            {filtered.length === 0 ? "0 claims" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, filtered.length)} of ${filtered.length}`}
          </span>
          <div className="ee-pagination-btns">
            <button className="ee-btn ee-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="ee-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))}</span>
            <button className="ee-btn ee-btn-sm" disabled={page >= Math.ceil(filtered.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Page: Pending Approvals ─────────────────────────────── */
function PendingApprovalsPage({ onModal, expenses }) {
  const pending = (expenses || []).filter(e =>
    ["Pending L1", "Pending L2", "Info Requested", "Approved"].includes(e.status)
  );

  const buildSteps = (e) => {
    const s = e.status || "";
    const isInfo = isInfoStatus(s);
    const isPendingL2 = s === "Pending L2";
    const isApproved = isApprovedStatus(s);
    const l1Done = isApproved || isPendingL2;
    return [
      { circle: "ee-asc-done", content: <Mi icon="check" style={{ fontSize: 16 }} />, label: "Submitted", sub: e.date || "", connectorDone: true },
      {
        circle: l1Done ? "ee-asc-done" : (isInfo ? "ee-asc-active" : "ee-asc-active"),
        content: l1Done ? <Mi icon="check" style={{ fontSize: 16 }} /> : isInfo ? <Mi icon="info" style={{ fontSize: 14 }} /> : "L1",
        label: isInfo ? "Info Requested" : "Manager Review",
        sub: l1Done ? "Approved" : isInfo ? "Awaiting response" : "Pending",
        connectorDone: l1Done,
        activeStyle: isInfo ? { background: "var(--amber-bg)", color: "var(--amber)", border: "2px solid var(--amber)" } : undefined,
      },
      {
        circle: isApproved ? "ee-asc-done" : isPendingL2 ? "ee-asc-active" : "ee-asc-pending",
        content: isApproved ? <Mi icon="check" style={{ fontSize: 16 }} /> : "L2",
        label: "HR / Finance",
        sub: isApproved ? "Approved" : isPendingL2 ? "Pending" : "Not started",
        connectorDone: isApproved,
      },
      {
        circle: isApproved ? "ee-asc-active" : "ee-asc-pending",
        content: "₹",
        label: "Reimbursement",
        sub: isApproved ? "Scheduled" : "Pending",
        connectorDone: false,
        activeStyle: isApproved ? { background: "var(--violet-bg)", color: "var(--violet)", border: "2px solid var(--violet)" } : undefined,
      },
    ];
  };

  const getBanner = (e) => {
    const s = e.status || "";
    if (isInfoStatus(s)) return { cls: "ee-a-amber", icon: "warning_amber", msg: e.infoRequestMessage || "Action needed: Your approver has requested additional information." };
    if (isApprovedStatus(s)) return { cls: "ee-a-green", icon: "check_circle", msg: `Fully approved! ${fmtAmt(e.amount)} will be reimbursed in the next payment cycle.` };
    return { cls: "ee-a-blue", icon: "schedule", msg: `Submitted on ${fmtDate(e.date)}. Awaiting manager review.` };
  };

  const getAction = (e) => {
    const s = e.status || "";
    if (isInfoStatus(s)) return { label: "Respond Now", variant: " ee-btn-primary", border: "var(--amber-bd)" };
    if (isApprovedStatus(s)) return { label: "View Details", variant: "", border: "var(--green-bd)" };
    return { label: "View Details", variant: "", border: "var(--border)" };
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">Pending Approvals</div><div className="ee-page-sub">Track where your expenses are in the approval pipeline</div></div>
      </div>
      {pending.length === 0 && (
        <div className="ee-card" style={{ textAlign: "center", color: "var(--text3)", padding: 40, fontSize: 14 }}>
          <Mi icon="check_circle" style={{ fontSize: 40, color: "var(--green)", display: "block", margin: "0 auto 10px" }} />
          No expenses pending approval right now.
        </div>
      )}
      {pending.map((e) => {
        const steps = buildSteps(e);
        const banner = getBanner(e);
        const action = getAction(e);
        return (
          <div key={e.id} className="ee-card" style={{ border: `1px solid ${action.border}` }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 14 }}>
              <div>
                <span className="ee-exp-id" style={{ fontSize: 15, fontWeight: 700 }}>{e.id}</span>
                <span className={`ee-pill ${PILL_CLASS[e.statusLabel] || PILL_CLASS[e.status] || "ee-p-draft"}`} style={{ marginLeft: 10 }}>{e.statusLabel}</span>
                <div style={{ fontSize: 13, color: "var(--text2)", marginTop: 4 }}>{e.title} · {e.category} · {fmtAmt(e.amount)} · {fmtDate(e.date)}</div>
              </div>
              <button className={`ee-btn ee-btn-sm${action.variant}`} onClick={() => {
                if (action.label === "Download Slip") downloadSlip(e);
                else onModal("view-expense", e);
              }}>
                {action.label}
              </button>
            </div>
            <div className="ee-approval-track">
              {steps.map((s, j) => (
                <React.Fragment key={j}>
                  <div className="ee-apv-step">
                    <div className={`ee-apv-circle ${s.circle}`} style={s.activeStyle || {}}>{s.content}</div>
                    <div className="ee-apv-label">{s.label}</div>
                    <div className="ee-apv-sub">{s.sub}</div>
                  </div>
                  {j < steps.length - 1 && <div className={`ee-apv-connector${s.connectorDone ? " ee-apv-connector-done" : ""}`} />}
                </React.Fragment>
              ))}
            </div>
            <div className={`ee-alert ${banner.cls}`} style={{ marginTop: 14 }}>
              <Mi icon={banner.icon} /><span>{banner.msg}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ─── Page: Reimbursements ─────────────────────────────────── */
function ReimbursementsPage({ expenses, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const arr = expenses || [];
  const reimbursed = arr.filter(e => isReimbursedStatus(e.status));
  const approved = arr.filter(e => isApprovedStatus(e.status));
  const reimbTotal = reimbursed.reduce((s, e) => s + Number(e.amount || 0), 0);
  const pendingReimbTotal = approved.reduce((s, e) => s + Number(e.amount || 0), 0);

  const historyRows = [
    ...reimbursed.map(e => ({ date: e.date, title: e.title, ref: e.id, amount: e.amount, mode: e.payment, txn: e.transactionRef || "—", isPaid: true, expense: e })),
    ...approved.map(e => ({ date: e.date, title: e.title, ref: e.id, amount: e.amount, mode: e.payment, txn: "Pending", isPaid: false, expense: e })),
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">Reimbursements</div><div className="ee-page-sub">Track your reimbursement history and upcoming payments</div></div>
        <select className="ee-filter-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="ee-kpi-row-3">
        {[
          { label: "Total Reimbursed", val: fmtAmt(reimbTotal), sub: `Across ${reimbursed.length} expense${reimbursed.length !== 1 ? "s" : ""}`, icon: "check_circle", cls: "ee-ki-green" },
          { label: "Pending Reimbursement", val: fmtAmt(pendingReimbTotal), sub: `${approved.length} approved · awaiting payment`, icon: "account_balance_wallet", cls: "ee-ki-violet" },
          { label: "Expense Count", val: String(arr.length), sub: `${reimbursed.length} reimbursed · ${approved.length} approved`, icon: "receipt", cls: "ee-ki-blue" },
        ].map((k) => (
          <div key={k.label} className="ee-kpi" style={{ cursor: "default" }}>
            <div className="ee-kpi-top"><span className="ee-kpi-label">{k.label}</span><div className={`ee-kpi-icon ${k.cls}`}><Mi icon={k.icon} /></div></div>
            <div className="ee-kpi-val" style={{ fontSize: k.val.length > 8 ? 16 : 24 }}>{k.val}</div>
            <div className="ee-kpi-sub">{k.sub}</div>
          </div>
        ))}
      </div>
      <div className="ee-card" style={{ padding: 0 }}>
        <div style={{ padding: "14px 14px 0" }}><div className="ee-card-title">Reimbursement History</div><div className="ee-card-sub">Reimbursed &amp; approved expenses</div></div>
        <div className="ee-tbl-wrap" style={{ marginTop: 14, border: "none", borderRadius: 0 }}>
          <table className="ee-table">
            <thead><tr><th>Date</th><th>Expense Title</th><th>Ref </th><th>Amount</th><th>Mode</th><th>Txn Reference</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {historyRows.length === 0 && <tr><td colSpan={8} style={{ textAlign: "center", color: "var(--text3)", padding: 24 }}>No reimbursement history yet</td></tr>}
              {historyRows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((r, i) => (
                <tr key={i} style={!r.isPaid ? { background: "var(--amber-bg)" } : {}}>
                  <td>{fmtDate(r.date)}</td>
                  <td style={{ fontWeight: 500 }}>{r.title}</td>
                  <td style={{ fontSize: 12, color: "var(--accent)" }}>{r.ref}</td>
                  <td style={{ fontWeight: 600, color: r.isPaid ? "var(--green)" : "var(--amber)" }}>{fmtAmt(r.amount)}</td>
                  <td>{r.mode}</td>
                  <td style={{ fontFamily: "DM Sans,sans-serif", fontSize: 12, color: r.txn === "Pending" ? "var(--text3)" : "var(--text)" }}>{r.txn}</td>
                  <td><span className={`ee-pill ${r.isPaid ? "ee-p-reimbursed" : "ee-p-pending"}`}>{r.isPaid ? "Paid" : "Scheduled"}</span></td>
                  <td>{r.isPaid && <button className="ee-btn ee-btn-sm ee-btn-primary" onClick={() => downloadSlip(r.expense)}><Mi icon="download" style={{ fontSize: 13 }} /> Slip</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="ee-pagination">
          <span className="ee-pagination-info">
            {historyRows.length === 0 ? "0 records" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, historyRows.length)} of ${historyRows.length}`}
          </span>
          <div className="ee-pagination-btns">
            <button className="ee-btn ee-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="ee-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(historyRows.length / PAGE_SIZE))}</span>
            <button className="ee-btn ee-btn-sm" disabled={page >= Math.ceil(historyRows.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
      {pendingReimbTotal > 0 && (
        <div className="ee-reimb-card">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <div className="ee-reimb-lbl">Pending Reimbursement</div>
              <div className="ee-reimb-amount">{fmtAmt(pendingReimbTotal)}</div>
              <div className="ee-reimb-next">{approved.length} approved expense{approved.length !== 1 ? "s" : ""} awaiting payment cycle</div>
            </div>
            {/* <button onClick={() => toast.info("Downloading payment schedule...")}
              style={{ background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", color: "#fff", padding: "9px 16px", borderRadius: 8, fontSize: 13, cursor: "pointer", fontFamily: "Outfit,sans-serif" }}>
               Slip
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Page: Spend Analytics ────────────────────────────────── */
function SpendAnalyticsPage({ myAnalytics, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const totalYTD = Number(myAnalytics?.totalYTD || 0);
  const activeCount = Number(myAnalytics?.activeCount || 0);
  const avgAmt = activeCount > 0 ? Math.round(totalYTD / activeCount) : 0;
  const rejectedCount = Number(myAnalytics?.rejectedCount || 0);
  const totalFiled = Number(myAnalytics?.totalFiled || 0);
  const approvalRate = totalFiled > 0 ? Math.round(((totalFiled - rejectedCount) / totalFiled) * 100) : 100;
  const approvedCount = Number(myAnalytics?.approvedCount || 0);
  const pendingCount = Number(myAnalytics?.pendingCount || 0);

  // Category breakdown (pre-computed by backend)
  const catColors = ["var(--accent)", "var(--green)", "var(--amber)", "var(--red)", "var(--violet)"];
  const topCats = (myAnalytics?.categoryBreakdown || []).map(c => [c.category, Number(c.total)]);
  const catTotal = topCats.reduce((s, [, v]) => s + v, 0);
  const topCat = topCats[0];
  const donutGradient = topCats.length > 0 ? (() => {
    let deg = 0;
    return `conic-gradient(${topCats.map(([, v], i) => { const p = (v / catTotal) * 360; const seg = `${catColors[i]} ${deg}deg ${deg + p}deg`; deg += p; return seg; }).join(",")})`;
  })() : "conic-gradient(var(--border) 0deg 360deg)";

  // Payment method breakdown (pre-computed by backend)
  const topPay = (myAnalytics?.paymentBreakdown || []).map(p => [p.paymentMode, Number(p.total)]);
  const payTotal = topPay.reduce((s, [, v]) => s + v, 0);

  // Monthly trend (pre-computed by backend, format "2025-01")
  const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthEntries = (myAnalytics?.monthlyTotals || []).map(m => [m.month, Number(m.total)]);
  const maxMonth = Math.max(...monthEntries.map(([, v]) => v), 1);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">Spend Analytics</div><div className="ee-page-sub">Visual breakdown of your expense patterns</div></div>
        <select className="ee-filter-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="ee-kpi-row">
        {[
          { label: "Total Spent (YTD)", val: fmtAmt(totalYTD), icon: "receipt", cls: "ee-ki-blue" },
          { label: "Largest Category", val: topCat ? topCat[0] : "—", sub: topCat ? `${fmtAmt(topCat[1])} · ${catTotal > 0 ? Math.round((topCat[1] / catTotal) * 100) : 0}% of total` : "No data", icon: "category", cls: "ee-ki-amber" },
          { label: "Avg Expense Amount", val: fmtAmt(avgAmt), sub: `${activeCount} expenses`, icon: "calculate", cls: "ee-ki-green" },
          { label: "Approval Rate", val: `${approvalRate}%`, sub: rejectedCount > 0 ? `${rejectedCount} rejection${rejectedCount > 1 ? "s" : ""}` : "No rejections", icon: "thumb_up", cls: "ee-ki-violet" },
        ].map((k) => (
          <div key={k.label} className="ee-kpi" style={{ cursor: "default" }}>
            <div className="ee-kpi-top"><span className="ee-kpi-label">{k.label}</span><div className={`ee-kpi-icon ${k.cls}`}><Mi icon={k.icon} /></div></div>
            <div className="ee-kpi-val" style={{ fontSize: k.val.length > 6 ? 16 : 24 }}>{k.val}</div>
            {k.sub && <div className="ee-kpi-sub">{k.sub}</div>}
          </div>
        ))}
      </div>
      <div className="ee-two-col">
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Monthly Spend Trend</div><div className="ee-card-sub">Last 6 months</div></div>
          {monthEntries.length > 0 ? (
            <div className="ee-bar-chart">
              {monthEntries.map(([key, val]) => {
                const parts = key.split("-");
                const label = parts.length === 2 ? (MONTH_SHORT[parseInt(parts[1]) - 1] || parts[1]) : key;
                const h = Math.round((val / maxMonth) * 100);
                return (
                  <div key={key} className="ee-bar-wrap">
                    <div className="ee-bar" style={{ height: `${h}%`, background: h === 100 ? "var(--accent)" : "var(--accent-mid)" }} />
                    <div className="ee-bar-lbl">{label}</div>
                    <div className="ee-bar-amt">{fmtAmt(val)}</div>
                  </div>
                );
              })}
            </div>
          ) : <div style={{ textAlign: "center", color: "var(--text3)", padding: "30px 0", fontSize: 13 }}>No data yet</div>}
        </div>
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Category Breakdown</div></div>
          {topCats.length > 0 ? (
            <div className="ee-donut-wrap" style={{ justifyContent: "center", flexDirection: "column", gap: 14 }}>
              <div className="ee-donut" style={{ margin: "0 auto", width: 100, height: 100, background: donutGradient }} />
              <div className="ee-legend" style={{ width: "100%" }}>
                {topCats.map(([cat, amt], i) => (
                  <div key={cat} className="ee-leg-item">
                    <div className="ee-leg-dot" style={{ background: catColors[i] }} />
                    <span className="ee-leg-lbl">{cat}</span>
                    <span className="ee-leg-val">{fmtAmt(amt)} · {catTotal > 0 ? Math.round((amt / catTotal) * 100) : 0}%</span>
                  </div>
                ))}
              </div>
            </div>
          ) : <div style={{ textAlign: "center", color: "var(--text3)", padding: "30px 0", fontSize: 13 }}>No data yet</div>}
        </div>
      </div>
      <div className="ee-three-col">
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Top Categories</div></div>
          {topCats.length > 0 ? topCats.map(([cat, amt], i) => (
            <div key={cat} className="ee-budget-item">
              <div className="ee-budget-top"><span className="ee-budget-name">{cat}</span><span className="ee-budget-pct" style={{ color: catColors[i] }}>{catTotal > 0 ? Math.round((amt / catTotal) * 100) : 0}%</span></div>
              <div style={{ fontSize: 11, color: "var(--text3)", fontFamily: "DM Sans,sans-serif", marginBottom: 3 }}>{fmtAmt(amt)}</div>
              <div className="ee-prog-wrap"><div className="ee-prog-fill" style={{ width: catTotal > 0 ? `${(amt / catTotal) * 100}%` : "0%", background: catColors[i] }} /></div>
            </div>
          )) : <div style={{ textAlign: "center", color: "var(--text3)", padding: "20px 0", fontSize: 13 }}>No data yet</div>}
        </div>
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Payment Methods</div></div>
          {topPay.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 4 }}>
              {topPay.map(([mode, amt]) => {
                const pct = payTotal > 0 ? Math.round((amt / payTotal) * 100) : 0;
                return (
                  <div key={mode}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
                      <span style={{ color: "var(--text2)" }}>{mode}</span>
                      <span style={{ fontWeight: 600 }}>{fmtAmt(amt)} · {pct}%</span>
                    </div>
                    <div className="ee-prog-wrap"><div className="ee-prog-fill" style={{ width: `${pct}%`, background: "var(--accent)" }} /></div>
                  </div>
                );
              })}
            </div>
          ) : <div style={{ textAlign: "center", color: "var(--text3)", padding: "20px 0", fontSize: 13 }}>No data yet</div>}
        </div>
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Approval Stats</div></div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 4 }}>
            {[
              { bg: "var(--green-bg)", textColor: "var(--green)", label: "Approved / Reimbursed", val: String(approvedCount), icon: "check_circle" },
              { bg: "var(--red-bg)", textColor: "var(--red)", label: "Rejected", val: String(rejectedCount), icon: "cancel" },
              { bg: "var(--amber-bg)", textColor: "var(--amber)", label: "Pending Approval", val: String(pendingCount), icon: "schedule" },
            ].map((s) => (
              <div key={s.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: 10, background: s.bg, borderRadius: 8 }}>
                <div>
                  <div style={{ fontSize: 12, color: s.textColor, fontWeight: 600 }}>{s.label}</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: s.textColor }}>{s.val}</div>
                </div>
                <Mi icon={s.icon} style={{ color: s.textColor, fontSize: 28 }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Page: Coming Soon ──────────────────────────────────────── */
function ComingSoonPage({ title = "Coming Soon" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 420, gap: 20, textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", background: "var(--accent-light, #ede9fe)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Mi icon="construction" style={{ fontSize: 38, color: "var(--accent, #7c3aed)" }} />
      </div>
      <div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text)", marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 14, color: "var(--text3, #9ca3af)", fontFamily: "'DM Sans', sans-serif", maxWidth: 340, lineHeight: 1.6 }}>
          This section is under development and will be available soon. Stay tuned!
        </div>
      </div>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", borderRadius: 20, padding: "5px 16px", fontSize: 12, fontWeight: 600 }}>
        <Mi icon="schedule" style={{ fontSize: 15 }} /> In Progress
      </span>
    </div>
  );
}

/* ─── Page: Settings ─────────────────────────────────────────── */
function SettingsPage() {
  const [notifs, setNotifs] = useState({ approval: true, budget: true, credited: true, clarification: true, weekly: false, recurring: false });
  const toggle = (k) => setNotifs((p) => ({ ...p, [k]: !p[k] }));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="ee-page-hdr">
        <div><div className="ee-page-title">Settings</div><div className="ee-page-sub">Manage your profile, bank account and notifications</div></div>
        <button className="ee-btn ee-btn-primary" onClick={() => toast.success("Settings saved!")}>Save Changes</button>
      </div>
      <div className="ee-two-col" style={{ alignItems: "start" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div className="ee-card">
            <div className="ee-card-head"><div className="ee-card-title">Profile Information</div></div>
            <div className="ee-form-row">
              <div className="ee-form-group"><label className="ee-form-label">Full Name</label><input className="ee-form-input" defaultValue="Anjali Khanna" /></div>
              <div className="ee-form-group"><label className="ee-form-label">Employee ID</label><input className="ee-form-input ee-form-input-ro" defaultValue="EMP-1042" readOnly /></div>
            </div>
            <div className="ee-form-row">
              <div className="ee-form-group"><label className="ee-form-label">Email</label><input className="ee-form-input" defaultValue="anjali.khanna@company.com" /></div>
              <div className="ee-form-group"><label className="ee-form-label">Department</label><input className="ee-form-input ee-form-input-ro" defaultValue="Product Engineering" readOnly /></div>
            </div>
            <div className="ee-form-group"><label className="ee-form-label">Reporting Manager</label><input className="ee-form-input ee-form-input-ro" defaultValue="Ravi Sharma" readOnly /></div>
          </div>
          <div className="ee-card">
            <div className="ee-card-head"><div className="ee-card-title">Reimbursement Bank Account</div></div>
            <div className="ee-form-row">
              <div className="ee-form-group"><label className="ee-form-label">Bank Name</label><input className="ee-form-input" defaultValue="HDFC Bank" /></div>
              <div className="ee-form-group"><label className="ee-form-label">Account Number</label><input className="ee-form-input" defaultValue="••••••••4521" /></div>
            </div>
            <div className="ee-form-row">
              <div className="ee-form-group"><label className="ee-form-label">IFSC Code</label><input className="ee-form-input" defaultValue="HDFC0001234" /></div>
              <div className="ee-form-group"><label className="ee-form-label">Account Type</label><select className="ee-form-select"><option>Savings</option><option>Current</option></select></div>
            </div>
          </div>
        </div>
        <div className="ee-card">
          <div className="ee-card-head"><div className="ee-card-title">Notification Preferences</div></div>
          {[
            { key: "approval", h: "Email on approval status change", p: "Get notified when your expense is approved or rejected" },
            { key: "budget", h: "Budget alert emails", p: "Alert at 80% and 100% of category budget" },
            { key: "credited", h: "Reimbursement credited notification", p: "Get notified when payment is processed to your account" },
            { key: "clarification", h: "Clarification request alerts", p: "Immediate alert when approver requests more info" },
            { key: "weekly", h: "Weekly expense summary", p: "Weekly digest of your expense activity every Monday" },
            { key: "recurring", h: "Recurring bill reminders", p: "Upcoming bill due date reminders" },
          ].map((row) => (
            <div key={row.key} className="ee-settings-row">
              <div className="ee-settings-row-left"><h4>{row.h}</h4><p>{row.p}</p></div>
              <Toggle on={notifs[row.key]} onToggle={() => toggle(row.key)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ─── Modals ──────────────────────────────────────────────── */
function ModalShell({ title, onClose, footer, children, size = "" }) {
  return (
    <div className="ee-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`ee-modal${size ? " ee-modal-" + size : ""}`}>
        <div className="ee-modal-head">
          <span className="ee-modal-title">{title}</span>
          <button className="ee-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="ee-modal-body">{children}</div>
        {footer && <div className="ee-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}

function NewExpenseModal({ onClose, categories, onSubmitted, initialData }) {
  const matchCatId = (catName) => {
    if (!catName || !categories.length) return "";
    const c = categories.find(c => c.name === catName);
    return c ? String(c.id) : "";
  };

  const [form, setForm] = useState({
    title: initialData?.title || "",
    categoryId: matchCatId(initialData?.category),
    amount: initialData?.amount ? String(initialData.amount) : "",
    expenseDate: initialData?.date || new Date().toISOString().split("T")[0],
    description: initialData?.desc || "",
    project: initialData?.project || "",
    paymentMode: initialData?.payment || "Personal Card",
  });
  const [receipt, setReceipt] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!form.title || !form.amount) { toast.error("Title and amount are required"); return; }
    setSubmitting(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });
      if (receipt) {
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = ev => resolve(ev.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(receipt);
        });
        fd.append("receiptBase64", base64);
        fd.append("receiptFileName", receipt.name);
      }
      const res = await fetch(`${API_BASE_URL}/api/expenses`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: fd,
      });
      if (res.ok) { toast.success("Expense submitted for approval!"); onSubmitted && onSubmitted(); onClose(); }
      else { toast.error("Failed to submit expense"); }
    } catch (e) { toast.error("Network error"); }
    finally { setSubmitting(false); }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <ModalShell title={initialData ? "Resubmit Expense" : "Submit New Expense"} onClose={onClose} size="lg"
      footer={<><button className="ee-btn ee-btn-primary" onClick={submit} disabled={submitting}><Mi icon="send" style={{ fontSize: 15 }} />{submitting ? "Submitting..." : "Save"}</button><button className="ee-btn" onClick={onClose}>Cancel</button></>}>
      {initialData?.rejectionReason && (
        <div className="ee-alert ee-a-red" style={{ marginBottom: 16 }}>
          <Mi icon="cancel" /><span><strong>Rejected reason:</strong> {initialData.rejectionReason}. Please correct and resubmit.</span>
        </div>
      )}
      <div className="ee-form-row">
        <div className="ee-form-group"><label className="ee-form-label">Expense Title <span className="ee-req">*</span></label><input className="ee-form-input" placeholder="e.g. Bangalore Client Meeting Travel" value={form.title} onChange={e => set("title", e.target.value)} /></div>
        <div className="ee-form-group"><label className="ee-form-label">Category <span className="ee-req">*</span></label>
          <select className="ee-form-select" value={form.categoryId} onChange={e => set("categoryId", e.target.value)}>
            <option value="">Select category</option>
            {categories.length > 0
              ? categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)
              : ["Travel", "Accommodation", "Meals & Entertainment", "Software & Licenses", "Hardware & Equipment", "Training & Certification", "Office Supplies", "Miscellaneous"].map(n => <option key={n}>{n}</option>)}
          </select>
        </div>
      </div>
      <div className="ee-form-row-3">
        <div className="ee-form-group"><label className="ee-form-label">Expense Date <span className="ee-req">*</span></label><input className="ee-form-input" type="date" value={form.expenseDate} onChange={e => set("expenseDate", e.target.value)} /></div>
        <div className="ee-form-group"><label className="ee-form-label">Amount (INR) <span className="ee-req">*</span></label><input className="ee-form-input" type="number" placeholder="0.00" value={form.amount} onChange={e => set("amount", e.target.value)} /></div>
        <div className="ee-form-group"><label className="ee-form-label">Payment Mode</label>
          <select className="ee-form-select" value={form.paymentMode} onChange={e => set("paymentMode", e.target.value)}>
            <option>Personal Card</option><option>Cash</option><option>UPI</option><option>Bank Transfer</option><option>Company Card</option>
          </select>
        </div>
      </div>
      <div className="ee-form-row">
        <div className="ee-form-group"><label className="ee-form-label">Project (Optional)</label>
          <input className="ee-form-input" placeholder="Project name" value={form.project} onChange={e => set("project", e.target.value)} />
        </div>
      </div>
      <div className="ee-form-group"><label className="ee-form-label">Description</label><textarea className="ee-form-textarea" placeholder="Describe the purpose and business justification..." value={form.description} onChange={e => set("description", e.target.value)} /></div>
      <div className="ee-form-group">
        <label className="ee-form-label">Attach Receipt / Invoice</label>
        <div className="ee-upload-zone" onClick={() => document.getElementById("ee-receipt-input").click()}>
          <Mi icon="cloud_upload" style={{ fontSize: 36, color: "var(--text3)" }} />
          <p>{receipt ? receipt.name : "Click to upload or drag & drop"}</p>
          <div className="ee-upload-hint">PDF, JPG, PNG · Max 10MB · Required if amount ≥ ₹500</div>
        </div>
        <input id="ee-receipt-input" type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: "none" }} onChange={e => setReceipt(e.target.files[0])} />
      </div>
    </ModalShell>
  );
}

function ViewExpenseModal({ expense, onClose, onModal }) {
  const e = expense || {};
  const actionLabel = isInfoStatus(e.status) ? "Provide Clarification"
    : isDraftStatus(e.status) ? "Submit Expense"
      : isRejectedStatus(e.status) ? "Resubmit"
        : null;

  const mgr = e.approvedByManager || "Manager";
  const admin = e.approvedByAdmin || "Admin";
  const txnRef = e.transactionRef || "—";

  const trailKey = isInfoStatus(e.status) ? "info"
    : isApprovedStatus(e.status) ? "approved"
      : isReimbursedStatus(e.status) ? "reimbursed"
        : isRejectedStatus(e.status) ? "rejected"
          : isDraftStatus(e.status) ? "draft"
            : "pending";

  const TRAILS = {
    pending: [
      { cls: "ee-td-green", icon: "check", title: "Submitted", desc: `Submitted on ${fmtDate(e.date)}` },
      { cls: "ee-td-amber", icon: "schedule", title: "Pending L1 Review", desc: `Awaiting approval from ${mgr}` },
      { cls: "ee-tl-dot-grey", icon: "hourglass_empty", title: "L2 Review (Admin)", desc: "Not started" },
      { cls: "ee-tl-dot-grey", icon: "payments", title: "Reimbursement", desc: "Pending" },
    ],
    info: [
      { cls: "ee-td-green", icon: "check", title: "Submitted", desc: `Submitted on ${fmtDate(e.date)}` },
      { cls: "ee-td-blue", icon: "info", title: "Clarification Requested", desc: `${mgr} · ${e.infoRequestMessage || "Additional info needed"}` },
      { cls: "ee-tl-dot-grey", icon: "hourglass_empty", title: "L2 Review (Admin)", desc: "Not started" },
      { cls: "ee-tl-dot-grey", icon: "payments", title: "Reimbursement", desc: "Pending" },
    ],
    approved: [
      { cls: "ee-td-green", icon: "check", title: "Submitted", desc: `Submitted on ${fmtDate(e.date)}` },
      { cls: "ee-td-green", icon: "check", title: "L1 Approved", desc: mgr },
      { cls: "ee-td-green", icon: "check", title: "L2 Approved", desc: admin },
      { cls: "ee-td-violet", icon: "schedule", title: "Reimbursement Scheduled", desc: "Pending payment cycle" },
    ],
    reimbursed: [
      { cls: "ee-td-green", icon: "check", title: "Submitted", desc: `Submitted on ${fmtDate(e.date)}` },
      { cls: "ee-td-green", icon: "check", title: "L1 Approved", desc: mgr },
      { cls: "ee-td-green", icon: "check", title: "L2 Approved", desc: admin },
      { cls: "ee-td-green", icon: "check", title: "Reimbursed", desc: `Ref: ${txnRef}` },
    ],
    rejected: [
      { cls: "ee-td-green", icon: "check", title: "Submitted", desc: `Submitted on ${fmtDate(e.date)}` },
      { cls: "ee-td-red", icon: "cancel", title: "Rejected", desc: `${mgr}${e.rejectionReason ? ` – ${e.rejectionReason}` : ""}` },
    ],
    draft: [{ cls: "ee-td-amber", icon: "edit", title: "Draft Saved", desc: "Not yet submitted" }],
  };

  const trail = TRAILS[trailKey] || [];

  return (
    <ModalShell title={e.id || "Expense Detail"} onClose={onClose} size="lg"
      footer={<><button className="ee-btn" onClick={onClose}>Close</button>{isReimbursedStatus(e.status) && <button className="ee-btn ee-btn-primary" onClick={() => downloadSlip(e)}><Mi icon="download" style={{ fontSize: 15 }} /> Slip</button>}{actionLabel && <button className="ee-btn ee-btn-primary" onClick={() => {
        if (isInfoStatus(e.status)) toast.info("Please submit your clarification above.");
        else if (isDraftStatus(e.status)) { toast.success(`${e.id} submitted for approval!`); onClose(); }
        else if (isRejectedStatus(e.status)) { onClose(); onModal("new-expense", e); }
      }}>{actionLabel}</button>}</>}>
      <div className="ee-detail-grid">
        <div className="ee-detail-field"><div className="ee-detail-field-label">Expense Number</div><div className="ee-detail-field-value" style={{ color: "var(--accent)" }}>{e.id}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Status</div><div className="ee-detail-field-value"><span className={`ee-pill ${PILL_CLASS[e.status]}`}>{e.statusLabel}</span></div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Category</div><div className="ee-detail-field-value">{e.category}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Expense Date</div><div className="ee-detail-field-value">{fmtDate(e.date)}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Amount</div><div className="ee-detail-field-value" style={{ color: "var(--green)" }}>{fmtAmt(e.amount)}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Payment Mode</div><div className="ee-detail-field-value">{e.payment}</div></div>
        {e.desc && <div className="ee-detail-field ee-detail-full"><div className="ee-detail-field-label">Description</div><div className="ee-detail-field-value" style={{ fontWeight: 400, fontSize: 13, color: "var(--text2)" }}>{e.desc}</div></div>}
      </div>
      {e.receiptFileName && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", marginBottom: 8, textTransform: "uppercase", letterSpacing: ".5px" }}>Attached Receipt</div>
          {e.receiptBase64 ? (() => {
            const ext = e.receiptFileName.split(".").pop().toLowerCase();
            const isImage = ["jpg", "jpeg", "png"].includes(ext);
            const mime = isImage ? `image/${ext === "jpg" ? "jpeg" : ext}` : "application/pdf";
            const dataUrl = e.receiptBase64.startsWith("data:")
              ? e.receiptBase64
              : `data:${mime};base64,${e.receiptBase64}`;
            return isImage ? (
              <div>
                <img src={dataUrl} alt={e.receiptFileName}
                  style={{ maxWidth: "100%", maxHeight: 280, borderRadius: 8, border: "1px solid var(--border)", objectFit: "contain", display: "block" }} />
                <a href={dataUrl} download={e.receiptFileName}
                  className="ee-btn ee-btn-sm" style={{ marginTop: 8, display: "inline-flex" }}>
                  <Mi icon="download" style={{ fontSize: 13 }} />Download
                </a>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
                <Mi icon="picture_as_pdf" style={{ color: "var(--red)", fontSize: 30 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{e.receiptFileName}</div>
                  <div style={{ fontSize: 11, color: "var(--text3)" }}>PDF Document</div>
                </div>
                <a href={dataUrl} download={e.receiptFileName} className="ee-btn ee-btn-sm ee-btn-primary" style={{ textDecoration: "none" }}>
                  <Mi icon="download" style={{ fontSize: 13 }} />Download
                </a>
              </div>
            );
          })() : (
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
              <Mi icon="attach_file" style={{ fontSize: 22, color: "var(--text3)" }} />
              <span style={{ fontSize: 13, color: "var(--text2)" }}>{e.receiptFileName}</span>
            </div>
          )}
        </div>
      )}
      {isRejectedStatus(e.status) && e.rejectionReason && (
        <div className="ee-alert ee-a-red" style={{ marginBottom: 16 }}>
          <Mi icon="cancel" />
          <div>
            <div style={{ fontWeight: 600, marginBottom: 2 }}>Rejection Reason</div>
            <div>{e.rejectionReason}</div>
          </div>
        </div>
      )}
      {isInfoStatus(e.status) && e.infoRequestMessage && (
        <div className="ee-alert ee-a-amber" style={{ marginBottom: 16 }}>
          <Mi icon="warning_amber" />
          <div>
            <div style={{ fontWeight: 600, marginBottom: 2 }}>Clarification Requested</div>
            <div>{e.infoRequestMessage}</div>
          </div>
        </div>
      )}
      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", marginBottom: 10, textTransform: "uppercase", letterSpacing: ".5px" }}>Approval Trail</div>
      <div className="ee-timeline">
        {trail.map((t, i) => (
          <div key={i} className="ee-tl-item">
            <div className={`ee-tl-dot ${t.cls}`}><Mi icon={t.icon} /></div>
            <div><div className="ee-tl-title">{t.title}</div><div className="ee-tl-desc">{t.desc}</div></div>
          </div>
        ))}
      </div>
      {isInfoStatus(e.status) && (
        <div style={{ marginTop: 16 }}>
          <label className="ee-form-label">Your Response <span className="ee-req">*</span></label>
          <textarea className="ee-form-textarea" placeholder="Type your clarification or attach the requested document..." />
          <div className="ee-upload-zone" style={{ marginTop: 8 }} onClick={() => toast.info("File picker opened")}>
            <Mi icon="attach_file" style={{ fontSize: 28, color: "var(--text3)" }} />
            <p style={{ fontSize: 12 }}>Attach supporting document</p>
          </div>
        </div>
      )}
    </ModalShell>
  );
}


function UploadModal({ onClose, expenses, onSubmitted }) {
  const [expenseId, setExpenseId] = useState("");
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!expenseId) { toast.error("Please select an expense"); return; }
    if (!file) { toast.error("Please select a file"); return; }
    setSubmitting(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        try {
          const base64 = ev.target.result;
          const res = await fetch(`${API_BASE_URL}/api/expenses/${expenseId}/receipt`, {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ receiptBase64: base64, receiptFileName: file.name }),
          });
          if (res.ok) {
            toast.success("Receipt uploaded successfully!");
            onSubmitted && onSubmitted();
            onClose();
          } else {
            toast.error("Upload failed: " + await res.text());
          }
        } catch { toast.error("Network error"); }
        finally { setSubmitting(false); }
      };
      reader.readAsDataURL(file);
    } catch { toast.error("Failed to read file"); setSubmitting(false); }
  };

  return (
    <ModalShell title="Upload Receipt" onClose={onClose} size="sm"
      footer={<><button className="ee-btn ee-btn-primary" onClick={submit} disabled={submitting}><Mi icon="upload" style={{ fontSize: 15 }} />{submitting ? "Uploading..." : "Upload"}</button><button className="ee-btn" onClick={onClose}>Cancel</button></>}>
      <div className="ee-form-group">
        <label className="ee-form-label">Link to Expense <span className="ee-req">*</span></label>
        <select className="ee-form-select" value={expenseId} onChange={e => setExpenseId(e.target.value)}>
          <option value="">Select expense...</option>
          {(expenses || []).filter(e => !isReimbursedStatus(e.status)).map(e => (
            <option key={e.id} value={e.id}>{e.id} – {e.title || e.category}</option>
          ))}
        </select>
      </div>
      <div className="ee-upload-zone" onClick={() => document.getElementById("ee-upload-rcpt-input").click()}>
        <Mi icon="cloud_upload" style={{ fontSize: 44, color: "var(--text3)" }} />
        <p>{file ? file.name : "Click to choose file"}</p>
        <div className="ee-upload-hint">PDF, JPG, PNG · Max 10MB</div>
      </div>
      <input id="ee-upload-rcpt-input" type="file" accept=".pdf,.jpg,.jpeg,.png"
        style={{ display: "none" }} onChange={e => setFile(e.target.files[0])} />
    </ModalShell>
  );
}

/* ─── Claim slip download ─────────────────────────────────── */
const downloadClaimSlip = (claim) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;

  const dark = [24, 25, 42];
  const muted = [100, 102, 120];
  const border = [220, 222, 232];
  const blue = [37, 99, 235];
  const green = [22, 163, 74];
  const violet = [124, 58, 237];

  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);

  const hline = (y) => {
    dc(border);
    doc.setLineWidth(0.3);
    doc.line(margin, y, W - margin, y);
  };

  // ── Header ───────────────────────────────────────────────
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  tc(blue);
  doc.text("Balsuite ", margin, 22);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  tc(muted);
  doc.text("Claim Reimbursement Slip", margin, 28);

  doc.setFont("courier", "normal");
  doc.setFontSize(9);
  tc(blue);
  doc.text(claim.id || "—", W - margin, 22, { align: "right" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });

  hline(34);

  // ── Amount ───────────────────────────────────────────────
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  tc(muted);
  doc.text("Total reimbursed", margin, 44);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  tc(green);
  doc.text(`Rs. ${Number(claim.total).toLocaleString("en-IN")}`, margin, 56);

  hline(63);

  // ── Borderless 2-column fields ────────────────────────────
  const fields = [
    ["Claim ID", claim.id || "—"],
    ["Period", claim.period || "—"],
    ["Title", claim.title || "—"],
    ["No. expenses", String(claim.items ?? "—")],
    ["Employee", claim.employee || "—"],
    ["Status", claim.statusLabel || claim.status || "—"],
  ];

  const colW = cW / 2;
  const cellH = 14;
  let y = 70;

  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col];
      if (!f) return;
      const x = margin + col * colW;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      tc(muted);
      doc.text(f[0], x, y);

      const isStatus = f[0] === "Status";
      const isClaimId = f[0] === "Claim ID";
      const isPeriod = f[0] === "Period";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      tc(isStatus ? green : isClaimId ? blue : isPeriod ? violet : dark);
      doc.text(String(f[1]), x, y + 7);
    });

    y += cellH;
  }

  hline(y + 4);

  // ── Footer ───────────────────────────────────────────────
  const genDate = new Date().toLocaleDateString("en-IN", {
    day: "numeric", month: "long", year: "numeric",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  tc(muted);
  doc.text(
    `Generated ${genDate}  ·  Balsuite Expense Management System`,
    W / 2, y + 11, { align: "center" }
  );

  doc.save(`claim-slip-${claim.id}.pdf`);
};

/* ─── Modal: View Claim ───────────────────────────────────── */
function ViewClaimModal({ claim, onClose }) {
  const c = claim || {};
  return (
    <ModalShell title={c.id || "Claim Detail"} onClose={onClose} size="sm"
      footer={<button className="ee-btn" onClick={onClose}>Close</button>}>
      <div className="ee-detail-grid">
        <div className="ee-detail-field"><div className="ee-detail-field-label">Claim ID</div><div className="ee-detail-field-value" style={{ color: "var(--accent)" }}>{c.id}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Status</div><div className="ee-detail-field-value"><span className={`ee-pill ${PILL_CLASS[c.statusLabel] || PILL_CLASS[c.status] || "ee-p-draft"}`}>{c.statusLabel || c.status}</span></div></div>
        <div className="ee-detail-field ee-detail-full"><div className="ee-detail-field-label">Title</div><div className="ee-detail-field-value">{c.title}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Period</div><div className="ee-detail-field-value">{c.period}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">No. of Expenses</div><div className="ee-detail-field-value">{c.items}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Total Amount</div><div className="ee-detail-field-value" style={{ color: "var(--green)" }}>{fmtAmt(c.total)}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Employee</div><div className="ee-detail-field-value">{c.employee}</div></div>
      </div>
    </ModalShell>
  );
}

/* ─── Page: My Internal Expenses ──────────────────────────── */
function MyInternalExpensesPage({ onModal, expenses, onRefresh, onYearChange }) {
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);

  const curYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: curYear - 2023 + 1 }, (_, i) => curYear - i);

  const intPill = (s) => {
    if (s === "Pending") return "ee-p-pending";
    if (s === "Approved") return "ee-p-approved";
    if (s === "Paid") return "ee-p-reimbursed";
    if (s === "Overdue" || s === "Rejected") return "ee-p-rejected";
    return "ee-p-draft";
  };

  const rows = (expenses || []).filter(e => {
    const q = search.toLowerCase();
    const matchSearch = !q || (e.internalId || "").toLowerCase().includes(q)
      || (e.title || "").toLowerCase().includes(q) || (e.vendor || "").toLowerCase().includes(q);
    const matchStatus = filterStatus === "All" || e.status === filterStatus;
    return matchSearch && matchStatus;
  });
  const paged = rows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div className="ee-page-hdr">
        <div>
          <div className="ee-page-title">Internal Expenses</div>
          <div className="ee-page-sub">Company expenses you submitted · {rows.length} records in {year}</div>
        </div>
        <button className="ee-btn ee-btn-primary" onClick={() => onModal("new-internal-expense")}>
          <Mi icon="add" style={{ fontSize: 14 }} /> New Submission
        </button>
      </div>
      <div className="ee-filter-bar">
        <select className="ee-filter-select" value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(0); onYearChange && onYearChange(y); }}>
          {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select className="ee-filter-select" value={filterStatus} onChange={e => { setFilterStatus(e.target.value); setPage(0); }}>
          <option value="All">All Status</option>
          {["Pending", "Approved", "Paid", "Overdue", "Rejected", "Draft"].map(s => <option key={s}>{s}</option>)}
        </select>
        <input className="ee-search-field" placeholder="Search by title, vendor, ref..." value={search}
          onChange={e => { setSearch(e.target.value); setPage(0); }} />
        <button className="ee-btn" onClick={() => { setSearch(""); setFilterStatus("All"); setYear(new Date().getFullYear()); setPage(0); }}>Clear</button>
      </div>
      <div className="ee-card" style={{ padding: 0 }}>
        <div className="ee-tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table className="ee-table">
            <thead>
              <tr><th>Ref</th><th>Title</th><th>Type</th><th>Vendor</th><th>Amount</th><th>Bill Month</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {rows.length === 0
                ? <tr><td colSpan={8} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No internal expenses found</td></tr>
                : paged.map(e => (
                  <tr key={e.internalId}>
                    <td><span className="ee-exp-id" style={{ color: "var(--violet)" }}>{e.internalId}</span></td>
                    <td style={{ fontWeight: 500 }}>{e.title}</td>
                    <td style={{ color: "var(--text2)", fontSize: 13 }}>{e.type ? e.type.charAt(0) + e.type.slice(1).toLowerCase() : "—"}</td>
                    <td style={{ color: "var(--text2)", fontSize: 13 }}>{e.vendor || "—"}</td>
                    <td style={{ fontWeight: 600 }}>{fmtAmt(e.amount)}</td>
                    <td style={{ color: "var(--text2)", fontSize: 13 }}>{e.billMonth || "—"}</td>
                    <td><span className={`ee-pill ${intPill(e.status)}`}>{e.status}</span></td>
                    <td><button className="ee-btn ee-btn-sm" onClick={() => onModal("view-internal", e)}>View</button></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className="ee-pagination">
          <span className="ee-pagination-info">
            {rows.length === 0 ? "0 records" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, rows.length)} of ${rows.length}`}
          </span>
          <div className="ee-pagination-btns">
            <button className="ee-btn ee-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="ee-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(rows.length / PAGE_SIZE))}</span>
            <button className="ee-btn ee-btn-sm" disabled={page >= Math.ceil(rows.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Modal: New Internal Expense ─────────────────────────── */
const DEFAULT_INT_TYPES = ["Grocery", "Utility", "Rent", "Maintenance", "Misc"];

function NewInternalExpenseModal({ onClose, intCategories, intPermission, onSubmitted }) {
  const cats = intCategories || [];

  // allowed types from permission (comma-separated uppercase) — filter category list
  const allowedTypeSet = intPermission?.allowedTypes
    ? new Set(intPermission.allowedTypes.split(",").map(t => t.trim().toUpperCase()))
    : null; // null = no restriction (shouldn't happen for employees but safe)

  const allowedCatIdSet = intPermission?.allowedCategoryIds
    ? new Set(intPermission.allowedCategoryIds.split(",").map(s => s.trim()))
    : null;

  // derive types from categories filtered by permission
  const permittedCats = cats.filter(c =>
    (!allowedTypeSet || allowedTypeSet.has((c.type || "").toUpperCase())) &&
    (!allowedCatIdSet || allowedCatIdSet.has(String(c.id)))
  );
  const availableTypes = permittedCats.length > 0
    ? [...new Set(permittedCats.map(c => c.type).filter(Boolean))].sort()
    : (allowedTypeSet ? [...allowedTypeSet].sort() : DEFAULT_INT_TYPES);

  const [form, setForm] = useState({ title: "", type: "", category: "", vendor: "", amount: "", billMonth: "", notes: "" });
  const [submitting, setSubmitting] = useState(false);

  // categories for selected type, further filtered by allowedCategoryIds
  const typedCats = permittedCats.filter(c => c.type === form.type);
  const setField = (field, val) => setForm(f => ({ ...f, [field]: val }));

  const handleSubmit = async () => {
    if (!form.title.trim() || !form.amount || !form.type) { toast.error("Title, Type and Amount are required"); return; }
    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const r = await fetch(`${API_BASE_URL}/api/internal-expenses`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, type: form.type.toUpperCase(), amount: Number(form.amount) }),
      });
      if (!r.ok) throw new Error();
      toast.success("Internal expense submitted successfully");
      onSubmitted?.();
      onClose();
    } catch { toast.error("Failed to submit internal expense"); }
    finally { setSubmitting(false); }
  };

  return (
    <ModalShell title="New Internal Expense" onClose={onClose}
      footer={<>
        <button className="ee-btn" onClick={onClose} disabled={submitting}>Cancel</button>
        <button className="ee-btn ee-btn-primary" onClick={handleSubmit} disabled={submitting}>{submitting ? "Submitting…" : "Submit"}</button>
      </>}>
      <div className="ee-form-group">
        <label className="ee-form-label">Title <span className="ee-req">*</span></label>
        <input className="ee-form-input" placeholder="e.g. Office Grocery Purchase – May" value={form.title} onChange={e => setField("title", e.target.value)} />
      </div>
      <div className="ee-form-row">
        <div className="ee-form-group">
          <label className="ee-form-label">Type <span className="ee-req">*</span></label>
          <select className="ee-form-select" value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value, category: "" }))}>
            <option value="">— Select Type —</option>
            {availableTypes.map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()}</option>)}
          </select>
        </div>
        <div className="ee-form-group">
          <label className="ee-form-label">Category</label>
          <select className="ee-form-select" value={form.category} onChange={e => setField("category", e.target.value)} disabled={!form.type}>
            <option value="">— Select —</option>
            {typedCats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
        </div>
      </div>
      <div className="ee-form-row">
        <div className="ee-form-group">
          <label className="ee-form-label">Amount (₹) <span className="ee-req">*</span></label>
          <input className="ee-form-input" type="number" min="0" step="0.01" placeholder="0.00" value={form.amount} onChange={e => setField("amount", e.target.value)} />
        </div>
        <div className="ee-form-group">
          <label className="ee-form-label">Vendor / Supplier</label>
          <input className="ee-form-input" placeholder="e.g. Reliance Fresh" value={form.vendor} onChange={e => setField("vendor", e.target.value)} />
        </div>
      </div>
      <div className="ee-form-group">
        <label className="ee-form-label">Bill Month</label>
        <input className="ee-form-input" placeholder="e.g. May 2026" value={form.billMonth} onChange={e => setField("billMonth", e.target.value)} />
      </div>
      <div className="ee-form-group">
        <label className="ee-form-label">Notes</label>
        <textarea className="ee-form-textarea" placeholder="Additional details..." value={form.notes} onChange={e => setField("notes", e.target.value)} />
      </div>
    </ModalShell>
  );
}

/* ─── Modal: View Internal Expense ───────────────────────── */
function ViewInternalExpenseModal({ expense, onClose }) {
  const e = expense || {};
  const intPill = (s) => {
    if (s === "Pending") return "ee-p-pending";
    if (s === "Approved") return "ee-p-approved";
    if (s === "Paid") return "ee-p-reimbursed";
    if (s === "Overdue" || s === "Rejected") return "ee-p-rejected";
    return "ee-p-draft";
  };
  return (
    <ModalShell title={e.internalId || "Internal Expense"} onClose={onClose} size="sm"
      footer={<button className="ee-btn" onClick={onClose}>Close</button>}>
      <div className="ee-detail-grid">
        <div className="ee-detail-field"><div className="ee-detail-field-label">Reference</div><div className="ee-detail-field-value" style={{ color: "var(--violet)" }}>{e.internalId}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Status</div><div className="ee-detail-field-value"><span className={`ee-pill ${intPill(e.status)}`}>{e.status}</span></div></div>
        <div className="ee-detail-field ee-detail-full"><div className="ee-detail-field-label">Title</div><div className="ee-detail-field-value">{e.title}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Type</div><div className="ee-detail-field-value">{e.type ? e.type.charAt(0) + e.type.slice(1).toLowerCase() : "—"}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Category</div><div className="ee-detail-field-value">{e.category || "—"}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Amount</div><div className="ee-detail-field-value" style={{ color: "var(--green)" }}>{fmtAmt(e.amount)}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Vendor</div><div className="ee-detail-field-value">{e.vendor || "—"}</div></div>
        <div className="ee-detail-field"><div className="ee-detail-field-label">Bill Month</div><div className="ee-detail-field-value">{e.billMonth || "—"}</div></div>
        {e.notes && <div className="ee-detail-field ee-detail-full"><div className="ee-detail-field-label">Notes</div><div className="ee-detail-field-value" style={{ fontWeight: 400, fontSize: 13 }}>{e.notes}</div></div>}
        {e.rejectionReason && <div className="ee-detail-field ee-detail-full"><div className="ee-detail-field-label">Rejection Reason</div><div className="ee-detail-field-value" style={{ color: "var(--red)", fontWeight: 400, fontSize: 13 }}>{e.rejectionReason}</div></div>}
      </div>
    </ModalShell>
  );
}

/* ─── Main Export ────────────────────────────────────────── */
export default function EmployeeExpenseDashboard() {
  const [activePage, setActivePage] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [claims, setClaims] = useState([]);
  const [stats, setStats] = useState(null);
  const [categories, setCategories] = useState([]);
  const [myPending, setMyPending] = useState([]);
  const [myReimb, setMyReimb] = useState([]);
  const [myDashboard, setMyDashboard] = useState(null);
  const [myAnalytics, setMyAnalytics] = useState(null);
  const [internalExpenses, setInternalExpenses] = useState([]);
  const [intCategories, setIntCategories] = useState([]);
  const [intPermission, setIntPermission] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  const authH = () => { const t = localStorage.getItem("token"); return t && t !== "null" ? { Authorization: `Bearer ${t}` } : null; };

  const fetchExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expenses/my?year=${y}`, { headers: h }); if (r.ok) setExpenses(await r.json()); }, []);
  const fetchClaims = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expense-claims/my?year=${y}`, { headers: h }); if (r.ok) setClaims(await r.json()); }, []);
  const fetchStats = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/my/stats`, { headers: h }); if (r.ok) setStats(await r.json()); }, []);
  const fetchCats = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expense-categories/active`, { headers: h }); if (r.ok) setCategories(await r.json()); }, []);
  const fetchMyPending = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/my/pending`, { headers: h }); if (r.ok) setMyPending(await r.json()); }, []);
  const fetchMyReimb = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expenses/my/reimbursements?year=${y}`, { headers: h }); if (r.ok) setMyReimb(await r.json()); }, []);
  const fetchMyDashboard = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/my/dashboard`, { headers: h }); if (r.ok) setMyDashboard(await r.json()); }, []);
  const fetchMyAnalytics = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expenses/my/analytics?year=${y}`, { headers: h }); if (r.ok) setMyAnalytics(await r.json()); }, []);
  const fetchInternalExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; try { const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/internal-expenses/my?year=${y}`, { headers: h }); if (r.ok) setInternalExpenses(await r.json()); } catch (e) { console.error("fetchInternalExpenses:", e); } }, []);
  const fetchIntCategories = useCallback(async () => { const h = authH(); if (!h) return; try { const r = await fetch(`${API_BASE_URL}/api/internal-categories/active`, { headers: h }); if (r.ok) { const data = await r.json(); setIntCategories(data); } else { console.warn("fetchIntCategories status:", r.status); } } catch (e) { console.error("fetchIntCategories:", e); } }, []);
  const fetchIntPermission = useCallback(async () => { const h = authH(); if (!h) return; try { const r = await fetch(`${API_BASE_URL}/api/employee-internal-permissions/my`, { headers: h }); if (r.ok) setIntPermission(await r.json()); else setIntPermission(null); } catch (e) { setIntPermission(null); } }, []);

  const loadPage = useCallback(async (page) => {
    setPageLoading(true);
    try {
      switch (page) {
        case "dashboard": await Promise.all([fetchMyDashboard(), fetchStats()]); break;
        case "my-expenses": await fetchExpenses(); break;
        case "my-claims": await fetchClaims(); break;
        case "pending-approvals": await fetchMyPending(); break;
        case "reimbursements": await fetchMyReimb(); break;
        case "spend-analytics": await fetchMyAnalytics(); break;
        case "internal-expenses": await fetchInternalExpenses(); break;
        default: break;
      }
    } catch (err) { console.error("Fetch error:", err); }
    finally { setPageLoading(false); }
  }, [fetchExpenses, fetchClaims, fetchStats, fetchMyPending, fetchMyReimb, fetchMyDashboard, fetchMyAnalytics, fetchInternalExpenses]);

  useEffect(() => {
    fetchCats();
    fetchIntCategories();
    fetchIntPermission();
    loadPage("dashboard");
  }, [fetchCats, fetchIntCategories, fetchIntPermission, loadPage]);

  const onNav = (page) => { setActivePage(page); setNotifOpen(false); loadPage(page); };
  const onModal = (type, data) => { setModal({ type, data }); setNotifOpen(false); };
  const closeModal = () => setModal(null);

  const renderPage = () => {
    if (pageLoading) return (
      <div className="ee-spinner-wrap">
        <div className="ee-spinner" />
        <div className="ee-spinner-label">Loading...</div>
      </div>
    );
    switch (activePage) {
      case "dashboard": return <DashboardPage onNav={onNav} onModal={onModal} myDashboard={myDashboard} stats={stats} />;
      case "my-expenses": return <MyExpensesPage onModal={onModal} expenses={expenses} onRefresh={fetchExpenses} />;
      case "my-claims": return <MyClaimsPage onModal={onModal} claims={claims} onRefresh={fetchClaims} />;
      case "pending-approvals": return <PendingApprovalsPage onModal={onModal} expenses={myPending} />;
      case "reimbursements": return <ReimbursementsPage expenses={myReimb} onRefresh={fetchMyReimb} />;
      case "spend-analytics": return <SpendAnalyticsPage myAnalytics={myAnalytics} onRefresh={fetchMyAnalytics} />;
      case "internal-expenses": return <MyInternalExpensesPage onModal={onModal} expenses={internalExpenses} onRefresh={fetchInternalExpenses} onYearChange={fetchInternalExpenses} />;
      case "settings": return <ComingSoonPage title="Settings" />;
      default: return <DashboardPage onNav={onNav} onModal={onModal} myDashboard={myDashboard} stats={stats} />;
    }
  };

  const renderModal = () => {
    if (!modal) return null;
    const { type, data } = modal;
    if (type === "new-expense") return <NewExpenseModal onClose={closeModal} categories={categories} onSubmitted={async () => { await Promise.all([fetchMyDashboard(), fetchStats(), fetchExpenses()]); }} initialData={data} />;
    if (type === "view-expense") return <ViewExpenseModal expense={data} onClose={closeModal} onModal={onModal} />;
    if (type === "view-claim") return <ViewClaimModal claim={data} onClose={closeModal} />;
    if (type === "upload") return <UploadModal onClose={closeModal} expenses={myPending} onSubmitted={fetchMyPending} />;
    if (type === "new-internal-expense") return <NewInternalExpenseModal onClose={closeModal} intCategories={intCategories} intPermission={intPermission} onSubmitted={fetchInternalExpenses} />;
    if (type === "view-internal") return <ViewInternalExpenseModal expense={data} onClose={closeModal} />;
    return null;
  };

  return (
    <>
      <EmployeeNavbar />
      <style>{STYLES}</style>
      <div className="ee-root">
        <Sidebar active={activePage} onNav={onNav} onModal={onModal} expenses={myPending} intPermission={intPermission} />
        <div className="ee-main">
          <Topbar active={activePage} notifOpen={notifOpen} setNotifOpen={setNotifOpen} />
          <div className="ee-content">{renderPage()}</div>
        </div>
        {renderModal()}
      </div>
    </>
  );
}
